// import { useEffect, useState, useRef, useCallback } from "react";
// import {
//   Tabs,
//   Tab,
//   Box,
//   Button,
//   CircularProgress,
//   Dialog,
//   DialogContent,
//   DialogTitle,
//   Paper,
//   Typography,
//   Grid,
//   Card,
//   CardContent,
//   TextField,
//   InputAdornment,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Select,
//   Chip,
//   Divider,
//   Alert,
//   IconButton,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   Tooltip,
//   ToggleButton,
//   ToggleButtonGroup
// } from "@mui/material";
// import {
//   PictureAsPdf as PdfIcon,
//   Search as SearchIcon,
//   Clear as ClearIcon,
//   WarningAmber as WarningIcon,
//   CheckCircle as CheckCircleIcon,
//   Download as DownloadIcon,
//   Visibility as VisibilityIcon,
//   Print as PrintIcon,
//   Payment as PaymentIcon,
//   Close as CloseIcon,
//   BarChart as BarChartIcon,
//   ShowChart as ShowChartIcon,
//   PieChart as PieChartIcon,
//   TrendingUp as TrendingUpIcon,
//   Timeline as TimelineIcon
// } from "@mui/icons-material";
// import { format } from "date-fns";
// import { ExecutePostWithParams, GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";

// // Helper function to normalize currency values
// const normalizeCurrency = (paymentMode) => {
//   if (!paymentMode) return "unknown";
//   const mode = paymentMode.toLowerCase();
//   if (mode === "usd") return "usd";
//   if (mode === "birr" || mode === "etb") return "birr";
//   return mode;
// };

// // Tab Panel Component
// function TabPanel({ children, value, index, ...other }) {
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`arrear-tabpanel-${index}`}
//       aria-labelledby={`arrear-tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//     </div>
//   );
// }

// export default function ArrearReport() {
//   // State Management
//   const [tabValue, setTabValue] = useState(0);
//   const [arrearsData, setArrearsData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
  
//   // Filter States
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedPark, setSelectedPark] = useState("all");
//   const [selectedStatus, setSelectedStatus] = useState("all");
//   const [selectedCurrency, setSelectedCurrency] = useState("all");
//   const [selectedYear, setSelectedYear] = useState("all");
//   const [selectedMonth, setSelectedMonth] = useState("all");
  
//   // Year Range and Month Range States
//   const [startYear, setStartYear] = useState("all");
//   const [endYear, setEndYear] = useState("all");
//   const [startMonth, setStartMonth] = useState("all");
//   const [endMonth, setEndMonth] = useState("all");
  
//   const [parksList, setParksList] = useState([]);
  
//   // Chart States
//   const [chartType, setChartType] = useState('bar');
//   const [showChart, setShowChart] = useState(false);
//   const [chartCurrency, setChartCurrency] = useState('both');
//   const [showYearlyChart, setShowYearlyChart] = useState(false);
//   const [selectedParkForYearly, setSelectedParkForYearly] = useState("all");
  
//   // Dialog States
//   const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
//   const [selectedArrear, setSelectedArrear] = useState(null);
//   const [openPaymentDialog, setOpenPaymentDialog] = useState(false);
//   const [paymentAmount, setPaymentAmount] = useState("");
//   const [paymentNote, setPaymentNote] = useState("");
//   const [processingPayment, setProcessingPayment] = useState(false);
//   const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
//   const [paymentSuccess, setPaymentSuccess] = useState(null);

//   // Years and Months for filtering
//   // Generate last 10 years dynamically
// const getLastNYears = (n) => {
//     const currentYear = new Date().getFullYear();
//     const years = ["all"];
//     for (let i = 0; i < n; i++) {
//       years.push((currentYear - i).toString());
//     }
//     return years;
//   };
  
//   // Usage in your component
//   const years = getLastNYears(10);
//   const months = [
//     { value: "all", label: "All Months" },
//     { value: "01", label: "January" },
//     { value: "02", label: "February" },
//     { value: "03", label: "March" },
//     { value: "04", label: "April" },
//     { value: "05", label: "May" },
//     { value: "06", label: "June" },
//     { value: "07", label: "July" },
//     { value: "08", label: "August" },
//     { value: "09", label: "September" },
//     { value: "10", label: "October" },
//     { value: "11", label: "November" },
//     { value: "12", label: "December" }
//   ];

//   // Utility Functions
//   const formatCurrency = (amount, paymentMode) => {
//     if (!amount && amount !== 0) return "0.00";
    
//     const normalizedMode = normalizeCurrency(paymentMode);
//     const formatted = new Intl.NumberFormat('en-US', {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(Number(amount));
    
//     if (normalizedMode === "usd") {
//       return `$${formatted}`;
//     } else {
//       return `${formatted} ETB`;
//     }
//   };

//   const formatNumber = (number) => {
//     if (!number && number !== 0) return "0.00";
//     return new Intl.NumberFormat('en-US', {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(Number(number));
//   };

//   const formatDate = (date) => {
//     if (!date) return "N/A";
//     try {
//       return format(new Date(date), 'dd/MM/yyyy');
//     } catch {
//       return "Invalid Date";
//     }
//   };

//   const getStatusColor = (overdueDays) => {
//     if (overdueDays >= 90) return "error";
//     if (overdueDays >= 60) return "warning";
//     if (overdueDays >= 30) return "info";
//     if (overdueDays >= 1) return "warning";
//     return "success";
//   };

//   const getStatusText = (overdueDays) => {
//     if (overdueDays >= 90) return "Critical";
//     if (overdueDays >= 60) return "Severe";
//     if (overdueDays >= 30) return "Moderate";
//     if (overdueDays >= 1) return "Mild";
//     return "Current";
//   };

//   // Fetch data from API
//   useEffect(() => {
//     const fetchArrear = async () => {
//       setLoading(true);
//       try {
//         const resultData = await GetDataFromApiWithParams(`finances/arrearreport`);
//         console.log("Arrear Response:", resultData);
        
//         if (resultData && Array.isArray(resultData)) {
//           const formattedData = resultData.map(item => {
//             const overdueDays = item.overdue_date || 0;
//             const outstandingAmount = parseFloat(item.outstanding) || 0;
//             const paymentMode = item.payment_mode || "ETB";
            
//             // Extract year and month from due_date if available
//             let year = "2024";
//             let month = "01";
//             if (item.due_date) {
//               try {
//                 const dateObj = new Date(item.due_date);
//                 if (!isNaN(dateObj.getTime())) {
//                   year = format(dateObj, 'yyyy');
//                   month = format(dateObj, 'MM');
//                 }
//               } catch (e) {}
//             }
            
//             return {
//               id: item.agreement_id,
//               agreement_id: item.agreement_id,
//               company_name: item.company_name || "N/A",
//               park_name: item.park || "N/A",
//               payment_mode: paymentMode,
//               outstanding: outstandingAmount,
//               formattedOutstanding: formatCurrency(outstandingAmount, paymentMode),
//               due_date: item.due_date,
//               due_date_formatted: formatDate(item.due_date),
//               overdue_days: overdueDays,
//               status: getStatusText(overdueDays),
//               statusColor: getStatusColor(overdueDays),
//               tenant_name: item.company_name || "N/A",
//               investor_name: "N/A",
//               amount_due: outstandingAmount,
//               amount_paid: 0,
//               balance: outstandingAmount,
//               days_overdue: overdueDays,
//               formattedAmount: formatCurrency(outstandingAmount, paymentMode),
//               formattedPaid: formatCurrency(0, paymentMode),
//               formattedBalance: formatCurrency(outstandingAmount, paymentMode),
//               last_payment_date: null,
//               last_payment_formatted: "N/A",
//               description: `Arrears for ${item.company_name}`,
//               upin: "N/A",
//               contact_number: "N/A",
//               email: "N/A",
//               year: year,
//               month: month
//             };
//           });
          
//           setArrearsData(formattedData);
//           setFilteredData(formattedData);
          
//           const uniqueParks = [...new Set(formattedData.map(item => item.park_name).filter(Boolean))];
//           setParksList(uniqueParks);
//         } else {
//           console.log("No data received or invalid format");
//           setArrearsData([]);
//           setFilteredData([]);
//         }
//       } catch (error) {
//         console.error("Failed to fetch arrear:", error);
//         setArrearsData([]);
//         setFilteredData([]);
//       } finally {
//         setLoading(false);
//       }
//     };
    
//     fetchArrear();
//   }, []);

//   // Calculate summary statistics
//   const summaryStats = {
//     totalArrears: filteredData.reduce((sum, item) => sum + (item.outstanding || 0), 0),
//     totalCompanies: new Set(filteredData.map(item => item.agreement_id)).size,
//     averageArrears: filteredData.length > 0 ? filteredData.reduce((sum, item) => sum + (item.outstanding || 0), 0) / filteredData.length : 0,
//     criticalAccounts: filteredData.filter(item => (item.overdue_days || 0) >= 90).length,
//     totalOverdue: filteredData.filter(item => (item.overdue_days || 0) > 0).length,
//     recoveryRate: 0
//   };

//   const totalUSD = filteredData
//     .filter(item => normalizeCurrency(item.payment_mode) === "usd")
//     .reduce((sum, item) => sum + (item.outstanding || 0), 0);

//   const totalETB = filteredData
//     .filter(item => normalizeCurrency(item.payment_mode) === "birr")
//     .reduce((sum, item) => sum + (item.outstanding || 0), 0);

//   // Chart data preparation for USD and ETB separately
//   const getChartDataByCurrency = (currency) => {
//     const parkData = {};
//     const filteredByCurrency = filteredData.filter(item => {
//       const normalizedMode = normalizeCurrency(item.payment_mode);
//       if (currency.toLowerCase() === 'usd') {
//         return normalizedMode === 'usd';
//       } else {
//         return normalizedMode === 'birr';
//       }
//     });
    
//     filteredByCurrency.forEach(item => {
//       if (!parkData[item.park_name]) {
//         parkData[item.park_name] = {
//           totalBalance: 0,
//           totalDue: 0,
//           count: 0
//         };
//       }
//       parkData[item.park_name].totalBalance += item.outstanding || 0;
//       parkData[item.park_name].totalDue += item.outstanding || 0;
//       parkData[item.park_name].count++;
//     });
//     return parkData;
//   };

//   // Prepare yearly summary data for arrears (same format as Code 2)
//   const getYearlySummaryData = () => {
//     const yearlySummary = {};
    
//     filteredData.forEach(item => {
//       const year = item.year;
//       const amount = item.outstanding || 0;
//       const normalizedMode = normalizeCurrency(item.payment_mode);
      
//       if (!yearlySummary[year]) {
//         yearlySummary[year] = {
//           usdArrears: 0,
//           etbArrears: 0,
//           totalArrears: 0,
//           transactionCount: 0
//         };
//       }
      
//       if (normalizedMode === "usd") {
//         yearlySummary[year].usdArrears += amount;
//       } else if (normalizedMode === "birr") {
//         yearlySummary[year].etbArrears += amount;
//       }
      
//       yearlySummary[year].totalArrears += amount;
//       yearlySummary[year].transactionCount++;
//     });
    
//     // Sort years in ascending order
//     const sortedYears = Object.keys(yearlySummary).sort((a, b) => a - b);
//     const sortedSummary = {};
//     sortedYears.forEach(year => {
//       sortedSummary[year] = yearlySummary[year];
//     });
    
//     return sortedSummary;
//   };

//   // Prepare yearly data for a specific park
//   const getYearlyDataForPark = (parkName) => {
//     const parkYearlyData = {};
    
//     filteredData.forEach(item => {
//       if (item.park_name === parkName) {
//         const year = item.year;
//         const amount = item.outstanding || 0;
//         const normalizedMode = normalizeCurrency(item.payment_mode);
        
//         if (!parkYearlyData[year]) {
//           parkYearlyData[year] = {
//             usdArrears: 0,
//             etbArrears: 0,
//             totalArrears: 0
//           };
//         }
        
//         if (normalizedMode === "usd") {
//           parkYearlyData[year].usdArrears += amount;
//         } else if (normalizedMode === "birr") {
//           parkYearlyData[year].etbArrears += amount;
//         }
        
//         parkYearlyData[year].totalArrears += amount;
//       }
//     });
    
//     // Sort years
//     const sortedYears = Object.keys(parkYearlyData).sort((a, b) => a - b);
//     const sortedData = {};
//     sortedYears.forEach(year => {
//       sortedData[year] = parkYearlyData[year];
//     });
    
//     return sortedData;
//   };

//   // Filter Data
//   const applyFilters = useCallback(() => {
//     let filtered = [...arrearsData];
    
//     if (searchTerm) {
//       filtered = filtered.filter(item =>
//         item.company_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         item.agreement_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         item.park_name?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }
    
//     if (selectedPark !== "all") {
//       filtered = filtered.filter(item => item.park_name === selectedPark);
//     }
    
//     if (selectedStatus !== "all") {
//       filtered = filtered.filter(item => item.status === selectedStatus);
//     }
    
//     if (selectedCurrency !== "all") {
//       filtered = filtered.filter(item => 
//         normalizeCurrency(item.payment_mode) === selectedCurrency
//       );
//     }
    
//     // YEAR RANGE FILTER
//     if (startYear !== "all" || endYear !== "all") {
//       filtered = filtered.filter(item => {
//         const itemYear = parseInt(item.year);
        
//         let startYearNum = startYear !== "all" ? parseInt(startYear) : -Infinity;
//         let endYearNum = endYear !== "all" ? parseInt(endYear) : Infinity;
        
//         return itemYear >= startYearNum && itemYear <= endYearNum;
//       });
//     }
    
//     // MONTH RANGE FILTER
//     if (startMonth !== "all" || endMonth !== "all") {
//       filtered = filtered.filter(item => {
//         const itemMonth = parseInt(item.month);
        
//         let startMonthNum = startMonth !== "all" ? parseInt(startMonth) : 1;
//         let endMonthNum = endMonth !== "all" ? parseInt(endMonth) : 12;
        
//         return itemMonth >= startMonthNum && itemMonth <= endMonthNum;
//       });
//     }
    
//     // Keep single year filter for backward compatibility
//     if (selectedYear !== "all" && startYear === "all" && endYear === "all") {
//       filtered = filtered.filter(item => item.year === selectedYear);
//     }
    
//     // Keep single month filter for backward compatibility
//     if (selectedMonth !== "all" && startMonth === "all" && endMonth === "all") {
//       filtered = filtered.filter(item => item.month === selectedMonth);
//     }
    
//     setFilteredData(filtered);
//     setPage(0);
//   }, [arrearsData, searchTerm, selectedPark, selectedStatus, selectedCurrency, selectedYear, selectedMonth, startYear, endYear, startMonth, endMonth]);

//   useEffect(() => {
//     applyFilters();
//   }, [applyFilters]);

//   // Handle View Details
//   const handleViewDetails = (row) => {
//     setSelectedArrear(row);
//     setOpenDetailsDialog(true);
//   };

//   // Handle Payment
//   const handlePayment = () => {
//     if (!paymentAmount || parseFloat(paymentAmount) <= 0) {
//       alert("Please enter a valid payment amount");
//       return;
//     }
    
//     if (parseFloat(paymentAmount) > selectedArrear.outstanding) {
//       alert("Payment amount cannot exceed outstanding balance");
//       return;
//     }
    
//     setProcessingPayment(true);
    
//     setTimeout(() => {
//       const newBalance = selectedArrear.outstanding - parseFloat(paymentAmount);
//       const paymentRecord = {
//         amount: parseFloat(paymentAmount),
//         date: new Date(),
//         note: paymentNote,
//         previousBalance: selectedArrear.outstanding,
//         newBalance: newBalance,
//         paymentMode: selectedArrear.payment_mode
//       };
      
//       setPaymentSuccess(paymentRecord);
//       setOpenPaymentDialog(false);
//       setOpenSuccessDialog(true);
      
//       const updatedData = arrearsData.map(item => {
//         if (item.id === selectedArrear.id) {
//           return {
//             ...item,
//             outstanding: newBalance,
//             formattedOutstanding: formatCurrency(newBalance, item.payment_mode),
//             balance: newBalance,
//             formattedBalance: formatCurrency(newBalance, item.payment_mode),
//             status: getStatusText(item.overdue_days),
//             statusColor: getStatusColor(item.overdue_days)
//           };
//         }
//         return item;
//       });
      
//       setArrearsData(updatedData);
//       setFilteredData(updatedData);
//       setProcessingPayment(false);
//       setPaymentAmount("");
//       setPaymentNote("");
//     }, 1500);
//   };

//   // Reset Filters
//   const resetFilters = () => {
//     setSearchTerm("");
//     setSelectedPark("all");
//     setSelectedStatus("all");
//     setSelectedCurrency("all");
//     setSelectedYear("all");
//     setSelectedMonth("all");
//     setStartYear("all");
//     setEndYear("all");
//     setStartMonth("all");
//     setEndMonth("all");
//   };

//   // Export to CSV
//   const handleExportCSV = () => {
//     const headers = ['Agreement ID', 'Company Name', 'Park Name', 'Payment Mode', 'Outstanding Balance', 'Due Date', 'Days Overdue', 'Status', 'Year', 'Month'];
//     const csvData = filteredData.map(item => [
//       item.agreement_id,
//       item.company_name,
//       item.park_name,
//       item.payment_mode,
//       item.formattedOutstanding,
//       item.due_date_formatted,
//       item.overdue_days,
//       item.status,
//       item.year,
//       item.month
//     ]);
    
//     const csvContent = [headers, ...csvData].map(row => row.join(',')).join('\n');
//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `arrears_report_${format(new Date(), 'yyyyMMdd')}.csv`;
//     a.click();
//     URL.revokeObjectURL(url);
//   };

//   // Handle page change
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   // Get current page data
//   const getCurrentPageData = () => {
//     const startIndex = page * rowsPerPage;
//     const endIndex = startIndex + rowsPerPage;
//     return filteredData.slice(startIndex, endIndex);
//   };

//   // Handle chart type change
//   const handleChartTypeChange = (event, newChartType) => {
//     if (newChartType !== null) {
//       setChartType(newChartType);
//     }
//   };

//   // Yearly Line Chart Component (same as Code 2)
//   const YearlyLineChart = ({ title, yearlyData, currencySymbol, currencyType }) => {
//     const years = Object.keys(yearlyData).sort((a, b) => a - b);
    
//     if (years.length === 0) {
//       return (
//         <Box sx={{ p: 3, textAlign: 'center' }}>
//           <Typography variant="body2" color="textSecondary">
//             No yearly data available
//           </Typography>
//         </Box>
//       );
//     }
    
//     const maxValue = Math.max(
//       ...Object.values(yearlyData).map(d => 
//         currencyType === 'usd' ? (d.usdArrears || 0) : 
//         currencyType === 'etb' ? (d.etbArrears || 0) : 
//         (d.totalArrears || 0)
//       ),
//       0
//     );
    
//     const chartHeight = 350;
//     const chartWidth = Math.max(600, years.length * 100);
//     const padding = { top: 30, right: 40, bottom: 60, left: 70 };
    
//     return (
//       <Box sx={{ p: 2, overflowX: 'auto' }}>
//         <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', mb: 3, textAlign: 'center' }}>
//           {title}
//         </Typography>
        
//         <svg width={chartWidth} height={chartHeight} viewBox={`0 0 ${chartWidth} ${chartHeight}`} preserveAspectRatio="xMidYMid meet">
//           {/* Grid lines */}
//           {[0, 25, 50, 75, 100].map((percent) => {
//             const y = chartHeight - padding.bottom - (percent / 100) * (chartHeight - padding.top - padding.bottom);
//             const value = (maxValue * percent) / 100;
//             return (
//               <g key={percent}>
//                 <line
//                   x1={padding.left}
//                   y1={y}
//                   x2={chartWidth - padding.right}
//                   y2={y}
//                   stroke="#e0e0e0"
//                   strokeWidth="1"
//                   strokeDasharray="4"
//                 />
//                 <text
//                   x={padding.left - 8}
//                   y={y}
//                   textAnchor="end"
//                   fontSize="10"
//                   fill="#666"
//                 >
//                   {currencySymbol}{formatNumber(value)}
//                 </text>
//               </g>
//             );
//           })}
          
//           {/* Line */}
//           <polyline
//             points={years.map((year, index) => {
//               const x = padding.left + (index / (years.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
//               let revenueValue = 0;
//               if (currencyType === 'usd') {
//                 revenueValue = yearlyData[year].usdArrears || 0;
//               } else if (currencyType === 'etb') {
//                 revenueValue = yearlyData[year].etbArrears || 0;
//               } else {
//                 revenueValue = yearlyData[year].totalArrears || 0;
//               }
//               const y = chartHeight - padding.bottom - (revenueValue / maxValue) * (chartHeight - padding.top - padding.bottom);
//               return `${x},${y}`;
//             }).join(' ')}
//             fill="none"
//             stroke={currencyType === 'usd' ? '#1976d2' : (currencyType === 'etb' ? '#2e7d32' : '#9c27b0')}
//             strokeWidth="2.5"
//           />
          
//           {/* Points and labels */}
//           {years.map((year, index) => {
//             const x = padding.left + (index / (years.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
//             let revenueValue = 0;
//             if (currencyType === 'usd') {
//               revenueValue = yearlyData[year].usdArrears || 0;
//             } else if (currencyType === 'etb') {
//               revenueValue = yearlyData[year].etbArrears || 0;
//             } else {
//               revenueValue = yearlyData[year].totalArrears || 0;
//             }
//             const y = chartHeight - padding.bottom - (revenueValue / maxValue) * (chartHeight - padding.top - padding.bottom);
            
//             return (
//               <g key={year}>
//                 <Tooltip
//                   title={
//                     <Box sx={{ p: 1 }}>
//                       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>Year: {year}</Typography>
//                       <Typography variant="body2" sx={{ color: '#fff' }}>
//                         {currencyType === 'usd' ? `USD Arrears: ${currencySymbol}${formatNumber(revenueValue)}` :
//                          currencyType === 'etb' ? `ETB Arrears: ${currencySymbol}${formatNumber(revenueValue)}` :
//                          `Total Arrears: ${currencySymbol}${formatNumber(revenueValue)}`}
//                       </Typography>
//                       {currencyType === 'both' && (
//                         <>
//                           <Typography variant="body2" sx={{ color: '#fff' }}>
//                             USD: ${formatNumber(yearlyData[year].usdArrears || 0)}
//                           </Typography>
//                           <Typography variant="body2" sx={{ color: '#fff' }}>
//                             ETB: {formatNumber(yearlyData[year].etbArrears || 0)} ETB
//                           </Typography>
//                         </>
//                       )}
//                     </Box>
//                   }
//                   arrow
//                   placement="top"
//                 >
//                   <circle
//                     cx={x}
//                     cy={y}
//                     r="6"
//                     fill={currencyType === 'usd' ? '#1976d2' : (currencyType === 'etb' ? '#2e7d32' : '#9c27b0')}
//                     stroke="white"
//                     strokeWidth="2"
//                     style={{ cursor: 'pointer' }}
//                   />
//                 </Tooltip>
//                 <text
//                   x={x}
//                   y={chartHeight - padding.bottom + 20}
//                   textAnchor="middle"
//                   fontSize="11"
//                   fontWeight="bold"
//                 >
//                   {year}
//                 </text>
//                 <text
//                   x={x}
//                   y={y - 8}
//                   textAnchor="middle"
//                   fontSize="9"
//                   fill="#666"
//                 >
//                   {currencySymbol}{formatNumber(revenueValue)}
//                 </text>
//               </g>
//             );
//           })}
          
//           {/* Axes */}
//           <line
//             x1={padding.left}
//             y1={padding.top}
//             x2={padding.left}
//             y2={chartHeight - padding.bottom}
//             stroke="#999"
//             strokeWidth="1.5"
//           />
//           <line
//             x1={padding.left}
//             y1={chartHeight - padding.bottom}
//             x2={chartWidth - padding.right}
//             y2={chartHeight - padding.bottom}
//             stroke="#999"
//             strokeWidth="1.5"
//           />
          
//           {/* Y-axis label */}
//           <text
//             x={20}
//             y={chartHeight / 2}
//             textAnchor="middle"
//             fontSize="11"
//             fill="#666"
//             transform={`rotate(-90, 20, ${chartHeight / 2})`}
//           >
//             Arrears Amount
//           </text>
          
//           {/* X-axis label */}
//           <text
//             x={chartWidth / 2}
//             y={chartHeight - 10}
//             textAnchor="middle"
//             fontSize="11"
//             fill="#666"
//           >
//             Year
//           </text>
//         </svg>
        
//         <Box sx={{ 
//           width: '100%', 
//           bgcolor: '#f5f5f5', 
//           mt: 3,
//           display: 'flex', 
//           flexDirection: 'column', 
//           alignItems: 'center', 
//           p: 2,
//           borderRadius: 1
//         }}>
//           <Typography variant="body2" color="textSecondary">
//             Years: {years.join(' → ')}
//           </Typography>
//         </Box>
//       </Box>
//     );
//   };

//   // Yearly Bar Chart Component (same as Code 2)
//   const YearlyBarChart = ({ title, yearlyData, currencySymbol, currencyType }) => {
//     const years = Object.keys(yearlyData).sort((a, b) => a - b);
    
//     if (years.length === 0) {
//       return (
//         <Box sx={{ p: 3, textAlign: 'center' }}>
//           <Typography variant="body2" color="textSecondary">
//             No yearly data available
//           </Typography>
//         </Box>
//       );
//     }
    
//     const maxValue = Math.max(
//       ...Object.values(yearlyData).map(d => 
//         currencyType === 'usd' ? (d.usdArrears || 0) : 
//         currencyType === 'etb' ? (d.etbArrears || 0) : 
//         (d.totalArrears || 0)
//       ),
//       0
//     );
    
//     const barColor = currencyType === 'usd' ? '#1976d2' : (currencyType === 'etb' ? '#2e7d32' : '#9c27b0');
    
//     return (
//       <Box sx={{ p: 2, overflowX: 'auto' }}>
//         <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', mb: 3, textAlign: 'center' }}>
//           {title}
//         </Typography>
        
//         <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 3, minHeight: 350, justifyContent: 'center', flexWrap: 'wrap' }}>
//           {years.map((year) => {
//             let revenueValue = 0;
//             if (currencyType === 'usd') {
//               revenueValue = yearlyData[year].usdArrears || 0;
//             } else if (currencyType === 'etb') {
//               revenueValue = yearlyData[year].etbArrears || 0;
//             } else {
//               revenueValue = yearlyData[year].totalArrears || 0;
//             }
            
//             const height = maxValue > 0 ? (revenueValue / maxValue) * 220 : 0;
            
//             return (
//               <Tooltip
//                 key={year}
//                 title={
//                   <Box sx={{ p: 1 }}>
//                     <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>Year: {year}</Typography>
//                     <Typography variant="body2" sx={{ color: '#fff' }}>
//                       {currencyType === 'usd' ? `USD Arrears: ${currencySymbol}${formatNumber(revenueValue)}` :
//                        currencyType === 'etb' ? `ETB Arrears: ${currencySymbol}${formatNumber(revenueValue)}` :
//                        `Total Arrears: ${currencySymbol}${formatNumber(revenueValue)}`}
//                     </Typography>
//                     {currencyType === 'both' && (
//                       <>
//                         <Typography variant="body2" sx={{ color: '#fff' }}>
//                           USD: ${formatNumber(yearlyData[year].usdArrears || 0)}
//                         </Typography>
//                         <Typography variant="body2" sx={{ color: '#fff' }}>
//                           ETB: {formatNumber(yearlyData[year].etbArrears || 0)} ETB
//                         </Typography>
//                       </>
//                     )}
//                   </Box>
//                 }
//                 arrow
//                 placement="top"
//               >
//                 <Box sx={{ textAlign: 'center', minWidth: 80, cursor: 'pointer' }}>
//                   <Box sx={{ 
//                     height: height, 
//                     width: '60px',
//                     bgcolor: barColor,
//                     borderRadius: '4px 4px 0 0',
//                     margin: '0 auto',
//                     transition: 'all 0.3s ease',
//                     '&:hover': {
//                       opacity: 0.8,
//                       transform: 'translateY(-5px)',
//                       boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
//                     }
//                   }} />
//                   <Typography variant="body2" sx={{ mt: 1, fontWeight: 'bold' }}>
//                     {year}
//                   </Typography>
//                   <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
//                     {currencySymbol}{formatNumber(revenueValue)}
//                   </Typography>
//                 </Box>
//               </Tooltip>
//             );
//           })}
//         </Box>
        
//         <Box sx={{ 
//           width: '100%', 
//           bgcolor: '#f5f5f5', 
//           mt: 3,
//           display: 'flex', 
//           flexDirection: 'column', 
//           alignItems: 'center', 
//           p: 2,
//           borderRadius: 1
//         }}>
//           <Typography variant="body2" color="textSecondary">
//             Total Years: {years.length} | Range: {years[0]} - {years[years.length - 1]}
//           </Typography>
//         </Box>
//       </Box>
//     );
//   };

//   // Yearly Chart Dashboard Component (same layout as Code 2)
//   const YearlyChartDashboard = () => {
//     const [yearlyChartType, setYearlyChartType] = useState('line');
//     const [yearlyCurrencyView, setYearlyCurrencyView] = useState('both');
    
//     const yearlySummaryData = getYearlySummaryData();
//     const parksListForYearly = [...new Set(filteredData.map(item => item.park_name).filter(Boolean))];
    
//     const getYearlyDataForDisplay = () => {
//       if (selectedParkForYearly !== "all") {
//         return getYearlyDataForPark(selectedParkForYearly);
//       }
//       return yearlySummaryData;
//     };
    
//     const displayData = getYearlyDataForDisplay();
    
//     const getChartTitle = () => {
//       let title = "Yearly Arrears Trend";
//       if (selectedParkForYearly !== "all") {
//         title += ` - ${selectedParkForYearly}`;
//       }
//       if (yearlyCurrencyView === 'usd') {
//         title += " (USD)";
//       } else if (yearlyCurrencyView === 'etb') {
//         title += " (ETB)";
//       } else {
//         title += " (USD + ETB)";
//       }
//       return title;
//     };
    
//     const getCurrencySymbol = () => {
//       if (yearlyCurrencyView === 'usd') return "$";
//       if (yearlyCurrencyView === 'etb') return "ETB";
//       return yearlyCurrencyView === 'both' ? "$" : "";
//     };
    
//     const renderYearlyChart = () => {
//       if (yearlyChartType === 'line') {
//         return (
//           <YearlyLineChart 
//             title={getChartTitle()}
//             yearlyData={displayData}
//             currencySymbol={getCurrencySymbol()}
//             currencyType={yearlyCurrencyView}
//           />
//         );
//       } else {
//         return (
//           <YearlyBarChart 
//             title={getChartTitle()}
//             yearlyData={displayData}
//             currencySymbol={getCurrencySymbol()}
//             currencyType={yearlyCurrencyView}
//           />
//         );
//       }
//     };
    
//     return (
//       <Box sx={{ mt: 2, mb: 3 }}>
//         {/* Controls for Yearly Chart - Same as Code 2 */}
//         <Paper elevation={1} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
//           <Grid container spacing={2} alignItems="center">
//             <Grid item xs={12} md={3}>
//               <FormControl fullWidth size="small">
//                 <InputLabel>Select Park</InputLabel>
//                 <Select
//                   value={selectedParkForYearly}
//                   onChange={(e) => setSelectedParkForYearly(e.target.value)}
//                   label="Select Park"
//                 >
//                   <MenuItem value="all">All Parks (Summary)</MenuItem>
//                   {parksListForYearly.map((park) => (
//                     <MenuItem key={park} value={park}>{park}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
            
//             <Grid item xs={12} md={2}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <Typography variant="body2" color="textSecondary">Chart Type:</Typography>
//                 <ToggleButtonGroup
//                   value={yearlyChartType}
//                   exclusive
//                   onChange={(e, val) => val && setYearlyChartType(val)}
//                   size="small"
//                 >
//                   <ToggleButton value="line">
//                     <Tooltip title="Line Chart"><ShowChartIcon fontSize="small" /></Tooltip>
//                   </ToggleButton>
//                   <ToggleButton value="bar">
//                     <Tooltip title="Bar Chart"><BarChartIcon fontSize="small" /></Tooltip>
//                   </ToggleButton>
//                 </ToggleButtonGroup>
//               </Box>
//             </Grid>
            
//             <Grid item xs={12} md={3}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <Typography variant="body2" color="textSecondary">Currency View:</Typography>
//                 <ToggleButtonGroup
//                   value={yearlyCurrencyView}
//                   exclusive
//                   onChange={(e, val) => val && setYearlyCurrencyView(val)}
//                   size="small"
//                 >
//                   <ToggleButton value="both">Both</ToggleButton>
//                   <ToggleButton value="usd">USD Only</ToggleButton>
//                   <ToggleButton value="etb">ETB Only</ToggleButton>
//                 </ToggleButtonGroup>
//               </Box>
//             </Grid>
//           </Grid>
//         </Paper>
        
//         {/* Yearly Chart Display - Same as Code 2 */}
//         <Paper elevation={1} sx={{ p: 2, bgcolor: '#fafafa', borderRadius: 2 }}>
//           {Object.keys(displayData).length === 0 ? (
//             <Box sx={{ p: 5, textAlign: 'center' }}>
//               <Typography variant="body2" color="textSecondary">
//                 No yearly data available for the selected filters
//               </Typography>
//             </Box>
//           ) : (
//             renderYearlyChart()
//           )}
//         </Paper>
//       </Box>
//     );
//   };

//   // Main Chart Component (By Park)
//   const SimpleChart = () => {
//     const usdChartData = getChartDataByCurrency('USD');
//     const etbChartData = getChartDataByCurrency('ETB');
    
//     return (
//       <Box sx={{ mt: 2, mb: 3 }}>
//         {/* Currency Selector */}
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//   <Typography variant="body2" color="textSecondary" sx={{ whiteSpace: 'nowrap' }}>
//     Currency View:
//   </Typography>
//   <ToggleButtonGroup
//     value={chartCurrency}
//     exclusive
//     onChange={(e, val) => val && setChartCurrency(val)}
//     size="small"
//     aria-label="currency view"
//     sx={{
//       '& .MuiToggleButton-root': {
//         borderColor: 'gray',
//         color: 'gray',
//         textTransform: 'none',
//         backgroundColor: 'transparent',
//         '&:hover': {
//           backgroundColor: '#f5f5f5',
//           borderColor: '#1976d2',
//         },
//         '&.Mui-selected': {
//           backgroundColor: '#e0e0e0',
//           color: 'black',
//           borderColor: 'gray',
//           '&:hover': {
//             backgroundColor: '#e0e0e0',
//           }
//         }
//       }
//     }}
//   >
//     <ToggleButton value="both" aria-label="both currencies">
//       Both
//     </ToggleButton>
//     <ToggleButton value="USD" aria-label="USD only">
//       USD Only
//     </ToggleButton>
//     <ToggleButton value="ETB" aria-label="ETB only">
//       ETB Only
//     </ToggleButton>
//   </ToggleButtonGroup>
// </Box>
        
//         {/* Chart Display */}
//         <Paper elevation={1} sx={{ p: 2, bgcolor: '#fafafa', borderRadius: 2 }}>
//           <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center', mb: 2 }}>
//             Arrears Analysis - {chartType === 'bar' ? 'Bar Chart' : 'Pie Chart'}
//           </Typography>
          
//           {chartCurrency === 'both' ? (
//             <Grid container spacing={3}>
//               <Grid item xs={12} md={6}>
//                 <Paper variant="outlined" sx={{ p: 1 }}>
//                   <Box sx={{ p: 2 }}>
//                     <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2' }}>
//                       USD Arrears by Park - Total: ${formatNumber(totalUSD)}
//                     </Typography>
//                     <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2, minHeight: 250, justifyContent: 'center', flexWrap: 'wrap' }}>
//                       {Object.entries(usdChartData).map(([park, parkData]) => {
//                         const maxValue = Math.max(...Object.values(usdChartData).map(d => d.totalBalance), 0);
//                         const height = maxValue > 0 ? (parkData.totalBalance / maxValue) * 180 : 0;
//                         return (
//                           <Tooltip key={park} title={`${park}: $${formatNumber(parkData.totalBalance)}`}>
//                             <Box sx={{ textAlign: 'center', minWidth: 80 }}>
//                               <Box sx={{ height: height, width: '50px', bgcolor: '#1976d2', borderRadius: '4px 4px 0 0', margin: '0 auto' }} />
//                               <Typography variant="caption">{park.length > 12 ? park.substring(0, 10) + '...' : park}</Typography>
//                             </Box>
//                           </Tooltip>
//                         );
//                       })}
//                     </Box>
//                   </Box>
//                 </Paper>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Paper variant="outlined" sx={{ p: 1 }}>
//                   <Box sx={{ p: 2 }}>
//                     <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#d32f2f' }}>
//                       ETB Arrears by Park - Total: {formatNumber(totalETB)} ETB
//                     </Typography>
//                     <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2, minHeight: 250, justifyContent: 'center', flexWrap: 'wrap' }}>
//                       {Object.entries(etbChartData).map(([park, parkData]) => {
//                         const maxValue = Math.max(...Object.values(etbChartData).map(d => d.totalBalance), 0);
//                         const height = maxValue > 0 ? (parkData.totalBalance / maxValue) * 180 : 0;
//                         return (
//                           <Tooltip key={park} title={`${park}: ${formatNumber(parkData.totalBalance)} ETB`}>
//                             <Box sx={{ textAlign: 'center', minWidth: 80 }}>
//                               <Box sx={{ height: height, width: '50px', bgcolor: '#d32f2f', borderRadius: '4px 4px 0 0', margin: '0 auto' }} />
//                               <Typography variant="caption">{park.length > 12 ? park.substring(0, 10) + '...' : park}</Typography>
//                             </Box>
//                           </Tooltip>
//                         );
//                       })}
//                     </Box>
//                   </Box>
//                 </Paper>
//               </Grid>
//             </Grid>
//           ) : chartCurrency === 'USD' ? (
//             <Box sx={{ p: 2 }}>
//               <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2' }}>
//                 USD Arrears by Park - Total: ${formatNumber(totalUSD)}
//               </Typography>
//               <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2, minHeight: 250, justifyContent: 'center', flexWrap: 'wrap' }}>
//                 {Object.entries(usdChartData).map(([park, parkData]) => {
//                   const maxValue = Math.max(...Object.values(usdChartData).map(d => d.totalBalance), 0);
//                   const height = maxValue > 0 ? (parkData.totalBalance / maxValue) * 180 : 0;
//                   return (
//                     <Tooltip key={park} title={`${park}: $${formatNumber(parkData.totalBalance)}`}>
//                       <Box sx={{ textAlign: 'center', minWidth: 80 }}>
//                         <Box sx={{ height: height, width: '50px', bgcolor: '#1976d2', borderRadius: '4px 4px 0 0', margin: '0 auto' }} />
//                         <Typography variant="caption">{park.length > 12 ? park.substring(0, 10) + '...' : park}</Typography>
//                       </Box>
//                     </Tooltip>
//                   );
//                 })}
//               </Box>
//             </Box>
//           ) : (
//             <Box sx={{ p: 2 }}>
//               <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#d32f2f' }}>
//                 ETB Arrears by Park - Total: {formatNumber(totalETB)} ETB
//               </Typography>
//               <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2, minHeight: 250, justifyContent: 'center', flexWrap: 'wrap' }}>
//                 {Object.entries(etbChartData).map(([park, parkData]) => {
//                   const maxValue = Math.max(...Object.values(etbChartData).map(d => d.totalBalance), 0);
//                   const height = maxValue > 0 ? (parkData.totalBalance / maxValue) * 180 : 0;
//                   return (
//                     <Tooltip key={park} title={`${park}: ${formatNumber(parkData.totalBalance)} ETB`}>
//                       <Box sx={{ textAlign: 'center', minWidth: 80 }}>
//                         <Box sx={{ height: height, width: '50px', bgcolor: '#d32f2f', borderRadius: '4px 4px 0 0', margin: '0 auto' }} />
//                         <Typography variant="caption">{park.length > 12 ? park.substring(0, 10) + '...' : park}</Typography>
//                       </Box>
//                     </Tooltip>
//                   );
//                 })}
//               </Box>
//             </Box>
//           )}
//         </Paper>
//       </Box>
//     );
//   };

//   return (
//     <Box sx={{ width: '100%', bgcolor: '#f5f5f5', minHeight: '100vh', p: 3 }}>
//       {/* Header Section */}
//       <Typography variant="h6" gutterBottom sx={{ color: '#1a237e', fontWeight: 'bold', textAlign: 'center', mb: 1 }}>
//         Arrears Report Dashboard
//       </Typography>
//       <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center', mb: 3 }}>
//         Monitor and manage outstanding payments across all industrial parks
//       </Typography>
      
//       {/* Summary Cards */}
//       <Grid container spacing={2} sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
//         <Grid item xs={12} sm={6} md={4} sx={{ display: 'flex', justifyContent: 'center' }}>
//           <Card sx={{ bgcolor: 'white', boxShadow: 1, minHeight: '70px', width: '100%' }}>
//             <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 }, textAlign: 'center' }}>
//               <Typography variant="caption" sx={{ color: '#999', fontSize: '0.7rem' }}>
//                 Total Outstanding Arrears
//               </Typography>
//               <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, my: 0.5 }}>
//                 <Typography variant="body2" sx={{ color: '#d32f2f', fontWeight: 'normal', fontSize: '0.875rem' }}>
//                   USD: ${formatNumber(totalUSD)}
//                 </Typography>
//                 <Box sx={{ width: '1px', height: '20px', bgcolor: '#ddd' }} />
//                 <Typography variant="body2" sx={{ color: '#d32f2f', fontWeight: 'normal', fontSize: '0.875rem' }}>
//                   ETB: {formatNumber(totalETB)} ETB
//                 </Typography>
//               </Box>
//               <Typography variant="caption" sx={{ color: '#999', fontSize: '0.7rem', display: 'block', mt: 0.5 }}>
//                 Across all parks
//               </Typography>
//             </CardContent>
//           </Card>
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', justifyContent: 'center' }}>
//           <Card sx={{ bgcolor: 'white', boxShadow: 1, minHeight: '70px', width: '100%' }}>
//             <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 }, textAlign: 'center' }}>
//               <Typography variant="caption" gutterBottom sx={{ color: '#666', display: 'block' }}>
//                 Critical overdue Accounts
//               </Typography>
//               <Typography variant="body2" sx={{ my: 0.5, color: 'black', fontWeight: 'normal', fontSize: '0.875rem' }}>
//                 {summaryStats.criticalAccounts}
//               </Typography>
//               <Typography variant="caption" sx={{ color: '#999', fontSize: '0.7rem' }}>
//                 Over 90 days overdue
//               </Typography>
//             </CardContent>
//           </Card>
//         </Grid>
        
//         <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', justifyContent: 'center' }}>
//           <Card sx={{ bgcolor: 'white', boxShadow: 1, minHeight: '70px', width: '100%' }}>
//             <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 }, textAlign: 'center' }}>
//               <Typography variant="caption" gutterBottom sx={{ color: '#666', display: 'block' }}>
//                 Active overdue Companies
//               </Typography>
//               <Typography variant="body2" sx={{ my: 0.5, color: 'black', fontWeight: 'normal', fontSize: '0.875rem' }}>
//                 {summaryStats.totalCompanies}
//               </Typography>
//               <Typography variant="caption" sx={{ color: '#999', fontSize: '0.7rem' }}>
//                 With outstanding balances
//               </Typography>
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>
      
//       {/* Filters Section */}
//       <Paper elevation={2} sx={{ p: 2, mb: 3, borderRadius: 2 }}>
//         <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
//           <Grid item xs={12} md={3}>
//             <TextField
//               fullWidth
//               size="small"
//               placeholder="Search by company, agreement ID or park..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <SearchIcon />
//                   </InputAdornment>
//                 ),
//                 endAdornment: searchTerm && (
//                   <InputAdornment position="end">
//                     <ClearIcon
//                       sx={{ cursor: 'pointer' }}
//                       onClick={() => setSearchTerm("")}
//                     />
//                   </InputAdornment>
//                 )
//               }}
//             />
//           </Grid>
          
//           <Grid item xs={12} md={1.5}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Park</InputLabel>
//               <Select
//                 value={selectedPark}
//                 onChange={(e) => setSelectedPark(e.target.value)}
//                 label="Park"
//               >
//                 <MenuItem value="all">All Parks</MenuItem>
//                 {parksList.map((park) => (
//                   <MenuItem key={park} value={park}>{park}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
          
//           <Grid item xs={12} md={1.5}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Status</InputLabel>
//               <Select
//                 value={selectedStatus}
//                 onChange={(e) => setSelectedStatus(e.target.value)}
//                 label="Status"
//               >
//                 <MenuItem value="all">All Status</MenuItem>
//                 <MenuItem value="Critical">Critical (90+ days)</MenuItem>
//                 <MenuItem value="Severe">Severe (60-89 days)</MenuItem>
//                 <MenuItem value="Moderate">Moderate (30-59 days)</MenuItem>
//                 <MenuItem value="Mild">Mild (1-29 days)</MenuItem>
//                 <MenuItem value="Current">Current</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>
          
//           {/* Currency Dropdown */}
//           <Grid item xs={12} md={1.5}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Currency</InputLabel>
//               <Select
//                 value={selectedCurrency}
//                 onChange={(e) => setSelectedCurrency(e.target.value)}
//                 label="Currency"
//               >
//                 <MenuItem value="all">All</MenuItem>
//                 <MenuItem value="usd">USD</MenuItem>
//                 <MenuItem value="birr">Birr</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>
          
//           <Grid item xs={12} md={2}>
//             <Box sx={{ display: 'flex', gap: 1 }}>
//               <Button
//                 fullWidth
//                 variant="outlined"
//                 onClick={resetFilters}
//                 startIcon={<ClearIcon />}
//                 size="small"
//                 sx={{ 
//                   textTransform: 'none',
//                   borderColor: '#1976d2',
//                   color: '#1976d2',
//                   mr: 0.5,
//                   '&:hover': {
//                     borderColor: '#1565c0',
//                     backgroundColor: 'rgba(25, 118, 210, 0.04)',
//                   },
//                 }}
//               >
//                 Reset
//               </Button>
//               <Button
//                 fullWidth
//                 variant="contained"
//                 color="inherit"
//                 size="small"
//                 onClick={handleExportCSV}
//                 startIcon={<DownloadIcon />}
//                 sx={{ textTransform: 'none' }}
//               >
//                 Export
//               </Button>
//             </Box>
//           </Grid>
          
//           <Grid item xs={12} md={2.5}>
//             <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
//               <Typography variant="body2" color="textSecondary" sx={{ mr: 0.5 }}>
//                 Chart:
//               </Typography>
//               <ToggleButtonGroup
//                 value={chartType}
//                 exclusive
//                 onChange={handleChartTypeChange}
//                 size="small"
//                 aria-label="chart type"
//               >
//                 <ToggleButton value="bar" aria-label="bar chart">
//                   <Tooltip title="Bar Chart">
//                     <BarChartIcon fontSize="small" />
//                   </Tooltip>
//                 </ToggleButton>
//                 <ToggleButton value="pie" aria-label="pie chart">
//                   <Tooltip title="Pie Chart">
//                     <PieChartIcon fontSize="small" />
//                   </Tooltip>
//                 </ToggleButton>
//               </ToggleButtonGroup>
//               <Button 
//                 variant="outlined" 
//                 size="small" 
//                 onClick={() => setShowChart(!showChart)} 
//                 sx={{ 
//                   minWidth: '120px', 
//                   textTransform: 'none',
//                   borderColor: '#1976d2',
//                   color: '#1976d2',
//                   '&:hover': { 
//                     borderColor: '#1976d2',
//                     backgroundColor: '#f5f5f5',
//                     color: '#1976d2'
//                   } 
//                 }}
//               >
//                 {showChart ? "Hide Chart" : "Show Chart"}
//               </Button>
//             </Box>
//           </Grid>
//         </Grid>
        
//         {/* Year and Month Range Filters */}
//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12} sm={6} md={2}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Year From</InputLabel>
//               <Select
//                 value={startYear}
//                 onChange={(e) => setStartYear(e.target.value)}
//                 label="Year From"
//               >
//                 {years.map((year) => (
//                   <MenuItem key={year} value={year}>{year === "all" ? "All Years" : year}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
          
//           <Grid item xs={12} sm={6} md={2}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Year To</InputLabel>
//               <Select
//                 value={endYear}
//                 onChange={(e) => setEndYear(e.target.value)}
//                 label="Year To"
//               >
//                 {years.map((year) => (
//                   <MenuItem key={year} value={year}>{year === "all" ? "All Years" : year}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
          
//           <Grid item xs={12} sm={6} md={2}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Month From</InputLabel>
//               <Select
//                 value={startMonth}
//                 onChange={(e) => setStartMonth(e.target.value)}
//                 label="Month From"
//               >
//                 {months.map((month) => (
//                   <MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
          
//           <Grid item xs={12} sm={6} md={2}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Month To</InputLabel>
//               <Select
//                 value={endMonth}
//                 onChange={(e) => setEndMonth(e.target.value)}
//                 label="Month To"
//               >
//                 {months.map((month) => (
//                   <MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
//         </Grid>
//       </Paper>
      
//       {/* Conditional Rendering: Show Chart OR Table */}
//       {showChart ? (
//         <>
//           {/* Chart Type Toggle Buttons - Same as Code 2 */}
//           <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center', gap: 2 }}>
//           <Button
//   variant={!showYearlyChart ? 'contained' : 'outlined'}
//   size="small"
//   onClick={() => setShowYearlyChart(false)}
//   sx={{ 
//     textTransform: 'none',
//     minWidth: '120px',
//     borderColor: '#1976d2',
//     color: '#1976d2',
//     ...(!showYearlyChart ? {
//       backgroundColor: '#e0e0e0',
//       '&:hover': {
//         backgroundColor: '#e0e0e0',
//       }
//     } : {
//       backgroundColor: 'transparent',
//       '&:hover': {
//         backgroundColor: '#e0e0e0',
//       }
//     })
//   }}
// >
//   By Park
// </Button>

// <Button
//   variant={showYearlyChart ? 'contained' : 'outlined'}
//   size="small"
//   onClick={() => setShowYearlyChart(true)}
//   sx={{ 
//     textTransform: 'none',
//     minWidth: '120px',
//     borderColor: '#1976d2',
//     color: '#1976d2',
//     ...(showYearlyChart ? {
//       backgroundColor: '#e0e0e0',
//       '&:hover': {
//         backgroundColor: '#e0e0e0',
//       }
//     } : {
//       backgroundColor: 'transparent',
//       '&:hover': {
//         backgroundColor: '#e0e0e0',
//       }
//     })
//   }}
// >
//   Yearly Trend
// </Button>
// </Box>
         
//           {!showYearlyChart ? (
//             <SimpleChart />
//           ) : (
//             <YearlyChartDashboard />
//           )}
//         </>
//       ) : (
//         <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
//           {loading ? (
//             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
//               <CircularProgress />
//               <Typography sx={{ ml: 2 }}>Loading arrears data...</Typography>
//             </Box>
//           ) : filteredData.length === 0 ? (
//             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
//               <Typography sx={{ color: 'text.secondary' }}>No arrears data available</Typography>
//             </Box>
//           ) : (
//             <>
//               <Box sx={{ p: 2, bgcolor: '#fafafa', borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
//                   Arrears Records
//                 </Typography>
//                 <Typography variant="body2" color="textSecondary">
//                   Showing {filteredData.length} of {arrearsData.length} records
//                 </Typography>
//               </Box>
              
//               <TableContainer>
//                 <Table size="small">
//                   <TableHead sx={{ bgcolor: '#f5f5f5' }}>
//                     <TableRow>
//                       <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Agreement ID</TableCell>
//                       <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Company Name</TableCell>
//                       <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Park</TableCell>
//                       <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Payment Mode</TableCell>
//                       <TableCell align="right" sx={{ py: 1, fontWeight: 'bold' }}>Outstanding</TableCell>
//                       <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Due Date</TableCell>
//                       <TableCell align="center" sx={{ py: 1, fontWeight: 'bold' }}>Days Overdue</TableCell>
                     
//                       <TableCell align="center" sx={{ py: 1, fontWeight: 'bold' }}>Actions</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {getCurrentPageData().map((row) => (
//                       <TableRow key={row.id} hover>
//                         <TableCell sx={{ py: 0.5 }}>{row.agreement_id}</TableCell>
//                         <TableCell sx={{ py: 0.5 }}>{row.company_name}</TableCell>
//                         <TableCell sx={{ py: 0.5 }}>{row.park_name}</TableCell>
//                         <TableCell sx={{ py: 0.5 }}>{row.payment_mode}</TableCell>
//                         <TableCell align="right" sx={{ py: 0.5, color: row.outstanding > 0 ? '#d32f2f' : 'inherit', fontWeight: row.outstanding > 0 ? 'bold' : 'normal' }}>
//                           {row.formattedOutstanding}
//                         </TableCell>
//                         <TableCell sx={{ py: 0.5 }}>{row.due_date_formatted}</TableCell>
//                         <TableCell align="center" sx={{ py: 0.5 }}>
//                           {row.overdue_days > 0 ? `${row.overdue_days} days` : 'Current'}
//                         </TableCell>
                        
//                         <TableCell align="center" sx={{ py: 0.5 }}>
//                           <Tooltip title="View Details">
//                             <IconButton
//                               size="small"
//                               color="primary"
//                               onClick={() => handleViewDetails(row)}
//                             >
//                               <VisibilityIcon />
//                             </IconButton>
//                           </Tooltip>
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
              
//               <TablePagination
//                 rowsPerPageOptions={[5, 10, 25, 50]}
//                 component="div"
//                 count={filteredData.length}
//                 rowsPerPage={rowsPerPage}
//                 page={page}
//                 onPageChange={handleChangePage}
//                 onRowsPerPageChange={handleChangeRowsPerPage}
//               />
              
//               {/* Summary Filter at Bottom Right */}
//               <Box sx={{ 
//   p: 2, 
//   bgcolor: '#fafafa', 
//   borderTop: '1px solid #e0e0e0',
//   display: 'flex',
//   justifyContent: 'flex-end',
//   alignItems: 'center',
//   gap: 3
// }}>
//   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//     <Typography variant="caption" sx={{ color: '#666', fontWeight: 'bold' }}>
//       Summary: {`Total Records: ${filteredData.length}`} | {' '}
//       {`Total USD: $${formatNumber(totalUSD)}`} | {' '}
//       {`Total ETB: ${formatNumber(totalETB)} ETB`} | {' '}
//       {`Critical: ${summaryStats.criticalAccounts}`}
//     </Typography>
//   </Box>
// </Box>
//             </>
//           )}
//         </Paper>
//       )}
      
//       {/* Details Dialog */}
//       <Dialog open={openDetailsDialog} onClose={() => setOpenDetailsDialog(false)} maxWidth="md" fullWidth>
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h5" sx={{ color: 'black', fontWeight: 'normal' }}>
//               Arrear Details
//             </Typography>
//             <IconButton onClick={() => setOpenDetailsDialog(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <Divider />
//         <DialogContent>
//           {selectedArrear && (
//             <Box sx={{ mt: 2 }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} md={6}>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
//                     <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
//                       Agreement ID:
//                     </Typography>
//                     <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
//                       {selectedArrear.agreement_id}
//                     </Typography>
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={12} md={6}>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
//                     <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
//                       Company Name:
//                     </Typography>
//                     <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
//                       {selectedArrear.company_name}
//                     </Typography>
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={12} md={6}>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
//                     <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
//                       Park Name:
//                     </Typography>
//                     <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
//                       {selectedArrear.park_name}
//                     </Typography>
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={12} md={6}>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
//                     <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
//                       Payment Mode:
//                     </Typography>
//                     <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
//                       {selectedArrear.payment_mode}
//                     </Typography>
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={12} md={6}>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
//                     <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
//                       Due Date:
//                     </Typography>
//                     <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
//                       {selectedArrear.due_date_formatted}
//                     </Typography>
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={12} md={6}>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
//                     <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
//                       Days Overdue:
//                     </Typography>
//                     <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
//                       {selectedArrear.overdue_days > 0 ? `${selectedArrear.overdue_days} days` : 'Current'}
//                     </Typography>
//                   </Box>
//                 </Grid>
                
//                 <Grid item xs={12}>
//                   <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
//                     <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
//                       Outstanding Balance:
//                     </Typography>
//                     <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
//                       {selectedArrear.formattedOutstanding}
//                     </Typography>
//                   </Box>
//                 </Grid>
//               </Grid>
//             </Box>
//           )}
//         </DialogContent>
//         <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
//           <Button onClick={() => setOpenDetailsDialog(false)} variant="outlined" sx={{ color: 'black', borderColor: '#ccc' }}>Close</Button>
//         </Box>
//       </Dialog>
      
//       {/* Payment Dialog */}
//       <Dialog open={openPaymentDialog} onClose={() => setOpenPaymentDialog(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Typography variant="h5" sx={{ color: '#1a237e', fontWeight: 'bold' }}>
//             Record Payment
//           </Typography>
//         </DialogTitle>
//         <Divider />
//         <DialogContent>
//           {selectedArrear && (
//             <Box sx={{ mt: 2 }}>
//               <Alert severity="info" sx={{ mb: 3 }}>
//                 <Typography variant="body2">
//                   <strong>Company:</strong> {selectedArrear.company_name}<br />
//                   <strong>Payment Mode:</strong> {selectedArrear.payment_mode}<br />
//                   <strong>Outstanding Balance:</strong> {selectedArrear.formattedOutstanding}
//                 </Typography>
//               </Alert>
              
//               <TextField
//                 fullWidth
//                 label={`Payment Amount (${selectedArrear.payment_mode === "USD" ? "$" : "ETB"})`}
//                 type="number"
//                 value={paymentAmount}
//                 onChange={(e) => setPaymentAmount(e.target.value)}
//                 placeholder="Enter amount"
//                 InputProps={{
//                   startAdornment: <InputAdornment position="start">{selectedArrear.payment_mode === "USD" ? "$" : "ETB"}</InputAdornment>
//                 }}
//                 sx={{ mb: 2 }}
//                 autoFocus
//               />
              
//               <TextField
//                 fullWidth
//                 label="Payment Note (Optional)"
//                 multiline
//                 rows={3}
//                 value={paymentNote}
//                 onChange={(e) => setPaymentNote(e.target.value)}
//                 placeholder="Add any notes about this payment..."
//               />
//             </Box>
//           )}
//         </DialogContent>
//         <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
//           <Button onClick={() => {
//             setOpenPaymentDialog(false);
//             setPaymentAmount("");
//             setPaymentNote("");
//           }}>
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={handlePayment}
//             disabled={processingPayment || !paymentAmount}
//           >
//             {processingPayment ? <CircularProgress size={24} /> : "Process Payment"}
//           </Button>
//         </Box>
//       </Dialog>
      
//       {/* Success Dialog */}
//       <Dialog open={openSuccessDialog} onClose={() => setOpenSuccessDialog(false)} maxWidth="sm" fullWidth>
//         <DialogTitle sx={{ bgcolor: '#4caf50', color: 'white' }}>
//           <Box display="flex" alignItems="center" gap={1}>
//             <CheckCircleIcon />
//             <Typography variant="h6">Payment Successful!</Typography>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           {paymentSuccess && (
//             <Box sx={{ mt: 2, p: 2 }}>
//               <Alert severity="success" sx={{ mb: 2 }}>
//                 Payment has been recorded successfully
//               </Alert>
              
//               <Grid container spacing={2}>
//                 <Grid item xs={6}>
//                   <Typography variant="subtitle2" color="textSecondary">Amount Paid</Typography>
//                   <Typography variant="h6" sx={{ color: '#4caf50' }}>
//                     {formatNumber(paymentSuccess.amount)} {paymentSuccess.paymentMode === "USD" ? "$" : "ETB"}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={6}>
//                   <Typography variant="subtitle2" color="textSecondary">Payment Date</Typography>
//                   <Typography variant="body1">{formatDate(paymentSuccess.date)}</Typography>
//                 </Grid>
//                 <Grid item xs={6}>
//                   <Typography variant="subtitle2" color="textSecondary">Previous Balance</Typography>
//                   <Typography variant="body1">
//                     {formatNumber(paymentSuccess.previousBalance)} {paymentSuccess.paymentMode === "USD" ? "$" : "ETB"}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={6}>
//                   <Typography variant="subtitle2" color="textSecondary">New Balance</Typography>
//                   <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
//                     {formatNumber(paymentSuccess.newBalance)} {paymentSuccess.paymentMode === "USD" ? "$" : "ETB"}
//                   </Typography>
//                 </Grid>
//                 {paymentSuccess.note && (
//                   <Grid item xs={12}>
//                     <Typography variant="subtitle2" color="textSecondary">Note</Typography>
//                     <Typography variant="body2">{paymentSuccess.note}</Typography>
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>
//           )}
//         </DialogContent>
//         <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}>
//           <Button 
//             variant="contained" 
//             onClick={() => {
//               setOpenSuccessDialog(false);
//               setPaymentSuccess(null);
//             }}
//           >
//             Close
//           </Button>
//         </Box>
//       </Dialog>
//     </Box>
//   );
// }
//*************************************************************************** */
import { useEffect, useState, useRef, useCallback } from "react";
import {
  Tabs,
  Tab,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Chip,
  Divider,
  Alert,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Tooltip,
  ToggleButton,
  ToggleButtonGroup
} from "@mui/material";
import {
  PictureAsPdf as PdfIcon,
  Search as SearchIcon,
  Clear as ClearIcon,
  WarningAmber as WarningIcon,
  CheckCircle as CheckCircleIcon,
  Download as DownloadIcon,
  Visibility as VisibilityIcon,
  Print as PrintIcon,
  Payment as PaymentIcon,
  Close as CloseIcon,
  BarChart as BarChartIcon,
  ShowChart as ShowChartIcon,
  PieChart as PieChartIcon,
  TrendingUp as TrendingUpIcon,
  Timeline as TimelineIcon
} from "@mui/icons-material";
import { format } from "date-fns";
import { ExecutePostWithParams, GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";

// Helper function to normalize currency values
const normalizeCurrency = (paymentMode) => {
  if (!paymentMode) return "unknown";
  const mode = paymentMode.toLowerCase();
  if (mode === "usd") return "usd";
  if (mode === "birr" || mode === "etb") return "birr";
  return mode;
};

// Helper function to convert to number
const toNumber = (value) => {
  if (typeof value === 'number' && !isNaN(value)) return value;
  if (typeof value === 'string') {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  }
  return 0;
};

// Format number with K, M, B abbreviations for data visualization (Cards only)
const formatNumberWithAbbreviation = (number) => {
  const num = toNumber(number);
  if (num === 0) return "0";
  
  const absNum = Math.abs(num);
  let formattedValue;
  let suffix = '';
  
  if (absNum >= 1e9) {
    formattedValue = (num / 1e9).toFixed(1);
    suffix = 'B';
  } else if (absNum >= 1e6) {
    formattedValue = (num / 1e6).toFixed(1);
    suffix = 'M';
  } else if (absNum >= 1e3) {
    formattedValue = (num / 1e3).toFixed(1);
    suffix = 'K';
  } else {
    formattedValue = num.toFixed(0);
  }
  
  // Remove .0 if it exists
  if (formattedValue.endsWith('.0')) {
    formattedValue = formattedValue.slice(0, -2);
  }
  
  return formattedValue + suffix;
};

// Format for card display with abbreviations
const formatCurrencyForCard = (amount, paymentMode) => {
  if (!amount && amount !== 0) return "0";
  
  const normalizedMode = normalizeCurrency(paymentMode);
  const formatted = formatNumberWithAbbreviation(amount);
  
  if (normalizedMode === "usd") {
    return `$${formatted}`;
  } else {
    return `${formatted} ETB`;
  }
};

// Tab Panel Component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`arrear-tabpanel-${index}`}
      aria-labelledby={`arrear-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function ArrearReport() {
  // State Management
  const [tabValue, setTabValue] = useState(0);
  const [arrearsData, setArrearsData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  // Filter States
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPark, setSelectedPark] = useState("all");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [selectedCurrency, setSelectedCurrency] = useState("all");
  const [selectedYear, setSelectedYear] = useState("all");
  const [selectedMonth, setSelectedMonth] = useState("all");
  
  // Year Range and Month Range States
  const [startYear, setStartYear] = useState("all");
  const [endYear, setEndYear] = useState("all");
  const [startMonth, setStartMonth] = useState("all");
  const [endMonth, setEndMonth] = useState("all");
  
  const [parksList, setParksList] = useState([]);
  
  // Chart States
  const [chartType, setChartType] = useState('bar');
  const [showChart, setShowChart] = useState(false);
  const [chartCurrency, setChartCurrency] = useState('both');
  const [showYearlyChart, setShowYearlyChart] = useState(false);
  const [selectedParkForYearly, setSelectedParkForYearly] = useState("all");
  
  // Dialog States
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [selectedArrear, setSelectedArrear] = useState(null);
  const [openPaymentDialog, setOpenPaymentDialog] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [paymentNote, setPaymentNote] = useState("");
  const [processingPayment, setProcessingPayment] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(null);

  // Years and Months for filtering
  // Generate last 10 years dynamically
const getLastNYears = (n) => {
    const currentYear = new Date().getFullYear();
    const years = ["all"];
    for (let i = 0; i < n; i++) {
      years.push((currentYear - i).toString());
    }
    return years;
  };
  
  // Usage in your component
  const years = getLastNYears(10);
  const months = [
    { value: "all", label: "All Months" },
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" }
  ];

  // Utility Functions
  const formatCurrency = (amount, paymentMode) => {
    if (!amount && amount !== 0) return "0.00";
    
    const normalizedMode = normalizeCurrency(paymentMode);
    const formatted = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(amount));
    
    if (normalizedMode === "usd") {
      return `$${formatted}`;
    } else {
      return `${formatted} ETB`;
    }
  };

  const formatNumber = (number) => {
    if (!number && number !== 0) return "0.00";
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(number));
  };

  const formatDate = (date) => {
    if (!date) return "N/A";
    try {
      return format(new Date(date), 'dd/MM/yyyy');
    } catch {
      return "Invalid Date";
    }
  };

  const getStatusColor = (overdueDays) => {
    if (overdueDays >= 90) return "error";
    if (overdueDays >= 60) return "warning";
    if (overdueDays >= 30) return "info";
    if (overdueDays >= 1) return "warning";
    return "success";
  };

  const getStatusText = (overdueDays) => {
    if (overdueDays >= 90) return "Critical";
    if (overdueDays >= 60) return "Severe";
    if (overdueDays >= 30) return "Moderate";
    if (overdueDays >= 1) return "Mild";
    return "Current";
  };

  // Fetch data from API
  useEffect(() => {
    const fetchArrear = async () => {
      setLoading(true);
      try {
        const resultData = await GetDataFromApiWithParams(`finances/arrearreport`);
        console.log("Arrear Response:", resultData);
        
        if (resultData && Array.isArray(resultData)) {
          const formattedData = resultData.map(item => {
            const overdueDays = item.overdue_date || 0;
            const outstandingAmount = parseFloat(item.outstanding) || 0;
            const paymentMode = item.payment_mode || "ETB";
            
            // Extract year and month from due_date if available
            let year = "2024";
            let month = "01";
            if (item.due_date) {
              try {
                const dateObj = new Date(item.due_date);
                if (!isNaN(dateObj.getTime())) {
                  year = format(dateObj, 'yyyy');
                  month = format(dateObj, 'MM');
                }
              } catch (e) {}
            }
            
            return {
              id: item.agreement_id,
              agreement_id: item.agreement_id,
              company_name: item.company_name || "N/A",
              park_name: item.park || "N/A",
              payment_mode: paymentMode,
              outstanding: outstandingAmount,
              formattedOutstanding: formatCurrency(outstandingAmount, paymentMode),
              due_date: item.due_date,
              due_date_formatted: formatDate(item.due_date),
              overdue_days: overdueDays,
              status: getStatusText(overdueDays),
              statusColor: getStatusColor(overdueDays),
              tenant_name: item.company_name || "N/A",
              investor_name: "N/A",
              amount_due: outstandingAmount,
              amount_paid: 0,
              balance: outstandingAmount,
              days_overdue: overdueDays,
              formattedAmount: formatCurrency(outstandingAmount, paymentMode),
              formattedPaid: formatCurrency(0, paymentMode),
              formattedBalance: formatCurrency(outstandingAmount, paymentMode),
              last_payment_date: null,
              last_payment_formatted: "N/A",
              description: `Arrears for ${item.company_name}`,
              upin: "N/A",
              contact_number: "N/A",
              email: "N/A",
              year: year,
              month: month
            };
          });
          
          setArrearsData(formattedData);
          setFilteredData(formattedData);
          
          const uniqueParks = [...new Set(formattedData.map(item => item.park_name).filter(Boolean))];
          setParksList(uniqueParks);
        } else {
          console.log("No data received or invalid format");
          setArrearsData([]);
          setFilteredData([]);
        }
      } catch (error) {
        console.error("Failed to fetch arrear:", error);
        setArrearsData([]);
        setFilteredData([]);
      } finally {
        setLoading(false);
      }
    };
    
    fetchArrear();
  }, []);

  // Calculate summary statistics
  const summaryStats = {
    totalArrears: filteredData.reduce((sum, item) => sum + (item.outstanding || 0), 0),
    totalCompanies: new Set(filteredData.map(item => item.agreement_id)).size,
    averageArrears: filteredData.length > 0 ? filteredData.reduce((sum, item) => sum + (item.outstanding || 0), 0) / filteredData.length : 0,
    criticalAccounts: filteredData.filter(item => (item.overdue_days || 0) >= 90).length,
    totalOverdue: filteredData.filter(item => (item.overdue_days || 0) > 0).length,
    recoveryRate: 0
  };

  const totalUSD = filteredData
    .filter(item => normalizeCurrency(item.payment_mode) === "usd")
    .reduce((sum, item) => sum + (item.outstanding || 0), 0);

  const totalETB = filteredData
    .filter(item => normalizeCurrency(item.payment_mode) === "birr")
    .reduce((sum, item) => sum + (item.outstanding || 0), 0);

  // Chart data preparation for USD and ETB separately
  const getChartDataByCurrency = (currency) => {
    const parkData = {};
    const filteredByCurrency = filteredData.filter(item => {
      const normalizedMode = normalizeCurrency(item.payment_mode);
      if (currency.toLowerCase() === 'usd') {
        return normalizedMode === 'usd';
      } else {
        return normalizedMode === 'birr';
      }
    });
    
    filteredByCurrency.forEach(item => {
      if (!parkData[item.park_name]) {
        parkData[item.park_name] = {
          totalBalance: 0,
          totalDue: 0,
          count: 0
        };
      }
      parkData[item.park_name].totalBalance += item.outstanding || 0;
      parkData[item.park_name].totalDue += item.outstanding || 0;
      parkData[item.park_name].count++;
    });
    return parkData;
  };

  // Prepare yearly summary data for arrears (same format as Code 2)
  const getYearlySummaryData = () => {
    const yearlySummary = {};
    
    filteredData.forEach(item => {
      const year = item.year;
      const amount = item.outstanding || 0;
      const normalizedMode = normalizeCurrency(item.payment_mode);
      
      if (!yearlySummary[year]) {
        yearlySummary[year] = {
          usdArrears: 0,
          etbArrears: 0,
          totalArrears: 0,
          transactionCount: 0
        };
      }
      
      if (normalizedMode === "usd") {
        yearlySummary[year].usdArrears += amount;
      } else if (normalizedMode === "birr") {
        yearlySummary[year].etbArrears += amount;
      }
      
      yearlySummary[year].totalArrears += amount;
      yearlySummary[year].transactionCount++;
    });
    
    // Sort years in ascending order
    const sortedYears = Object.keys(yearlySummary).sort((a, b) => a - b);
    const sortedSummary = {};
    sortedYears.forEach(year => {
      sortedSummary[year] = yearlySummary[year];
    });
    
    return sortedSummary;
  };

  // Prepare yearly data for a specific park
  const getYearlyDataForPark = (parkName) => {
    const parkYearlyData = {};
    
    filteredData.forEach(item => {
      if (item.park_name === parkName) {
        const year = item.year;
        const amount = item.outstanding || 0;
        const normalizedMode = normalizeCurrency(item.payment_mode);
        
        if (!parkYearlyData[year]) {
          parkYearlyData[year] = {
            usdArrears: 0,
            etbArrears: 0,
            totalArrears: 0
          };
        }
        
        if (normalizedMode === "usd") {
          parkYearlyData[year].usdArrears += amount;
        } else if (normalizedMode === "birr") {
          parkYearlyData[year].etbArrears += amount;
        }
        
        parkYearlyData[year].totalArrears += amount;
      }
    });
    
    // Sort years
    const sortedYears = Object.keys(parkYearlyData).sort((a, b) => a - b);
    const sortedData = {};
    sortedYears.forEach(year => {
      sortedData[year] = parkYearlyData[year];
    });
    
    return sortedData;
  };

  // Filter Data
  const applyFilters = useCallback(() => {
    let filtered = [...arrearsData];
    
    if (searchTerm) {
      filtered = filtered.filter(item =>
        item.company_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.agreement_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.park_name?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    if (selectedPark !== "all") {
      filtered = filtered.filter(item => item.park_name === selectedPark);
    }
    
    if (selectedStatus !== "all") {
      filtered = filtered.filter(item => item.status === selectedStatus);
    }
    
    if (selectedCurrency !== "all") {
      filtered = filtered.filter(item => 
        normalizeCurrency(item.payment_mode) === selectedCurrency
      );
    }
    
    // YEAR RANGE FILTER
    if (startYear !== "all" || endYear !== "all") {
      filtered = filtered.filter(item => {
        const itemYear = parseInt(item.year);
        
        let startYearNum = startYear !== "all" ? parseInt(startYear) : -Infinity;
        let endYearNum = endYear !== "all" ? parseInt(endYear) : Infinity;
        
        return itemYear >= startYearNum && itemYear <= endYearNum;
      });
    }
    
    // MONTH RANGE FILTER
    if (startMonth !== "all" || endMonth !== "all") {
      filtered = filtered.filter(item => {
        const itemMonth = parseInt(item.month);
        
        let startMonthNum = startMonth !== "all" ? parseInt(startMonth) : 1;
        let endMonthNum = endMonth !== "all" ? parseInt(endMonth) : 12;
        
        return itemMonth >= startMonthNum && itemMonth <= endMonthNum;
      });
    }
    
    // Keep single year filter for backward compatibility
    if (selectedYear !== "all" && startYear === "all" && endYear === "all") {
      filtered = filtered.filter(item => item.year === selectedYear);
    }
    
    // Keep single month filter for backward compatibility
    if (selectedMonth !== "all" && startMonth === "all" && endMonth === "all") {
      filtered = filtered.filter(item => item.month === selectedMonth);
    }
    
    setFilteredData(filtered);
    setPage(0);
  }, [arrearsData, searchTerm, selectedPark, selectedStatus, selectedCurrency, selectedYear, selectedMonth, startYear, endYear, startMonth, endMonth]);

  useEffect(() => {
    applyFilters();
  }, [applyFilters]);

  // Handle View Details
  const handleViewDetails = (row) => {
    setSelectedArrear(row);
    setOpenDetailsDialog(true);
  };

  // Handle Payment
  const handlePayment = () => {
    if (!paymentAmount || parseFloat(paymentAmount) <= 0) {
      alert("Please enter a valid payment amount");
      return;
    }
    
    if (parseFloat(paymentAmount) > selectedArrear.outstanding) {
      alert("Payment amount cannot exceed outstanding balance");
      return;
    }
    
    setProcessingPayment(true);
    
    setTimeout(() => {
      const newBalance = selectedArrear.outstanding - parseFloat(paymentAmount);
      const paymentRecord = {
        amount: parseFloat(paymentAmount),
        date: new Date(),
        note: paymentNote,
        previousBalance: selectedArrear.outstanding,
        newBalance: newBalance,
        paymentMode: selectedArrear.payment_mode
      };
      
      setPaymentSuccess(paymentRecord);
      setOpenPaymentDialog(false);
      setOpenSuccessDialog(true);
      
      const updatedData = arrearsData.map(item => {
        if (item.id === selectedArrear.id) {
          return {
            ...item,
            outstanding: newBalance,
            formattedOutstanding: formatCurrency(newBalance, item.payment_mode),
            balance: newBalance,
            formattedBalance: formatCurrency(newBalance, item.payment_mode),
            status: getStatusText(item.overdue_days),
            statusColor: getStatusColor(item.overdue_days)
          };
        }
        return item;
      });
      
      setArrearsData(updatedData);
      setFilteredData(updatedData);
      setProcessingPayment(false);
      setPaymentAmount("");
      setPaymentNote("");
    }, 1500);
  };

  // Reset Filters
  const resetFilters = () => {
    setSearchTerm("");
    setSelectedPark("all");
    setSelectedStatus("all");
    setSelectedCurrency("all");
    setSelectedYear("all");
    setSelectedMonth("all");
    setStartYear("all");
    setEndYear("all");
    setStartMonth("all");
    setEndMonth("all");
  };

  // Export to CSV
  const handleExportCSV = () => {
    const headers = ['Agreement ID', 'Company Name', 'Park Name', 'Payment Mode', 'Outstanding Balance', 'Due Date', 'Days Overdue', 'Status', 'Year', 'Month'];
    const csvData = filteredData.map(item => [
      item.agreement_id,
      item.company_name,
      item.park_name,
      item.payment_mode,
      item.formattedOutstanding,
      item.due_date_formatted,
      item.overdue_days,
      item.status,
      item.year,
      item.month
    ]);
    
    const csvContent = [headers, ...csvData].map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `arrears_report_${format(new Date(), 'yyyyMMdd')}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Get current page data
  const getCurrentPageData = () => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return filteredData.slice(startIndex, endIndex);
  };

  // Handle chart type change
  const handleChartTypeChange = (event, newChartType) => {
    if (newChartType !== null) {
      setChartType(newChartType);
    }
  };

  // Yearly Line Chart Component (same as Code 2)
  const YearlyLineChart = ({ title, yearlyData, currencySymbol, currencyType }) => {
    const years = Object.keys(yearlyData).sort((a, b) => a - b);
    
    if (years.length === 0) {
      return (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="textSecondary">
            No yearly data available
          </Typography>
        </Box>
      );
    }
    
    const maxValue = Math.max(
      ...Object.values(yearlyData).map(d => 
        currencyType === 'usd' ? (d.usdArrears || 0) : 
        currencyType === 'etb' ? (d.etbArrears || 0) : 
        (d.totalArrears || 0)
      ),
      0
    );
    
    const chartHeight = 350;
    const chartWidth = Math.max(600, years.length * 100);
    const padding = { top: 30, right: 40, bottom: 60, left: 70 };
    
    return (
      <Box sx={{ p: 2, overflowX: 'auto' }}>
        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', mb: 3, textAlign: 'center' }}>
          {title}
        </Typography>
        
        <svg width={chartWidth} height={chartHeight} viewBox={`0 0 ${chartWidth} ${chartHeight}`} preserveAspectRatio="xMidYMid meet">
          {/* Grid lines */}
          {[0, 25, 50, 75, 100].map((percent) => {
            const y = chartHeight - padding.bottom - (percent / 100) * (chartHeight - padding.top - padding.bottom);
            const value = (maxValue * percent) / 100;
            return (
              <g key={percent}>
                <line
                  x1={padding.left}
                  y1={y}
                  x2={chartWidth - padding.right}
                  y2={y}
                  stroke="#e0e0e0"
                  strokeWidth="1"
                  strokeDasharray="4"
                />
                <text
                  x={padding.left - 8}
                  y={y}
                  textAnchor="end"
                  fontSize="10"
                  fill="#666"
                >
                  {currencySymbol}{formatNumber(value)}
                </text>
              </g>
            );
          })}
          
          {/* Line */}
          <polyline
            points={years.map((year, index) => {
              const x = padding.left + (index / (years.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
              let revenueValue = 0;
              if (currencyType === 'usd') {
                revenueValue = yearlyData[year].usdArrears || 0;
              } else if (currencyType === 'etb') {
                revenueValue = yearlyData[year].etbArrears || 0;
              } else {
                revenueValue = yearlyData[year].totalArrears || 0;
              }
              const y = chartHeight - padding.bottom - (revenueValue / maxValue) * (chartHeight - padding.top - padding.bottom);
              return `${x},${y}`;
            }).join(' ')}
            fill="none"
            stroke={currencyType === 'usd' ? '#1976d2' : (currencyType === 'etb' ? '#2e7d32' : '#9c27b0')}
            strokeWidth="2.5"
          />
          
          {/* Points and labels */}
          {years.map((year, index) => {
            const x = padding.left + (index / (years.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
            let revenueValue = 0;
            if (currencyType === 'usd') {
              revenueValue = yearlyData[year].usdArrears || 0;
            } else if (currencyType === 'etb') {
              revenueValue = yearlyData[year].etbArrears || 0;
            } else {
              revenueValue = yearlyData[year].totalArrears || 0;
            }
            const y = chartHeight - padding.bottom - (revenueValue / maxValue) * (chartHeight - padding.top - padding.bottom);
            
            return (
              <g key={year}>
                <Tooltip
                  title={
                    <Box sx={{ p: 1 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>Year: {year}</Typography>
                      <Typography variant="body2" sx={{ color: '#fff' }}>
                        {currencyType === 'usd' ? `USD Arrears: ${currencySymbol}${formatNumber(revenueValue)}` :
                         currencyType === 'etb' ? `ETB Arrears: ${currencySymbol}${formatNumber(revenueValue)}` :
                         `Total Arrears: ${currencySymbol}${formatNumber(revenueValue)}`}
                      </Typography>
                      {currencyType === 'both' && (
                        <>
                          <Typography variant="body2" sx={{ color: '#fff' }}>
                            USD: ${formatNumber(yearlyData[year].usdArrears || 0)}
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#fff' }}>
                            ETB: {formatNumber(yearlyData[year].etbArrears || 0)} ETB
                          </Typography>
                        </>
                      )}
                    </Box>
                  }
                  arrow
                  placement="top"
                >
                  <circle
                    cx={x}
                    cy={y}
                    r="6"
                    fill={currencyType === 'usd' ? '#1976d2' : (currencyType === 'etb' ? '#2e7d32' : '#9c27b0')}
                    stroke="white"
                    strokeWidth="2"
                    style={{ cursor: 'pointer' }}
                  />
                </Tooltip>
                <text
                  x={x}
                  y={chartHeight - padding.bottom + 20}
                  textAnchor="middle"
                  fontSize="11"
                  fontWeight="bold"
                >
                  {year}
                </text>
                <text
                  x={x}
                  y={y - 8}
                  textAnchor="middle"
                  fontSize="9"
                  fill="#666"
                >
                  {currencySymbol}{formatNumber(revenueValue)}
                </text>
              </g>
            );
          })}
          
          {/* Axes */}
          <line
            x1={padding.left}
            y1={padding.top}
            x2={padding.left}
            y2={chartHeight - padding.bottom}
            stroke="#999"
            strokeWidth="1.5"
          />
          <line
            x1={padding.left}
            y1={chartHeight - padding.bottom}
            x2={chartWidth - padding.right}
            y2={chartHeight - padding.bottom}
            stroke="#999"
            strokeWidth="1.5"
          />
          
          {/* Y-axis label */}
          <text
            x={20}
            y={chartHeight / 2}
            textAnchor="middle"
            fontSize="11"
            fill="#666"
            transform={`rotate(-90, 20, ${chartHeight / 2})`}
          >
            Arrears Amount
          </text>
          
          {/* X-axis label */}
          <text
            x={chartWidth / 2}
            y={chartHeight - 10}
            textAnchor="middle"
            fontSize="11"
            fill="#666"
          >
            Year
          </text>
        </svg>
        
        <Box sx={{ 
          width: '100%', 
          bgcolor: '#f5f5f5', 
          mt: 3,
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          p: 2,
          borderRadius: 1
        }}>
          <Typography variant="body2" color="textSecondary">
            Years: {years.join(' → ')}
          </Typography>
        </Box>
      </Box>
    );
  };

  // Yearly Bar Chart Component (same as Code 2)
  const YearlyBarChart = ({ title, yearlyData, currencySymbol, currencyType }) => {
    const years = Object.keys(yearlyData).sort((a, b) => a - b);
    
    if (years.length === 0) {
      return (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="textSecondary">
            No yearly data available
          </Typography>
        </Box>
      );
    }
    
    const maxValue = Math.max(
      ...Object.values(yearlyData).map(d => 
        currencyType === 'usd' ? (d.usdArrears || 0) : 
        currencyType === 'etb' ? (d.etbArrears || 0) : 
        (d.totalArrears || 0)
      ),
      0
    );
    
    const barColor = currencyType === 'usd' ? '#1976d2' : (currencyType === 'etb' ? '#2e7d32' : '#9c27b0');
    
    return (
      <Box sx={{ p: 2, overflowX: 'auto' }}>
        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', mb: 3, textAlign: 'center' }}>
          {title}
        </Typography>
        
        <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 3, minHeight: 350, justifyContent: 'center', flexWrap: 'wrap' }}>
          {years.map((year) => {
            let revenueValue = 0;
            if (currencyType === 'usd') {
              revenueValue = yearlyData[year].usdArrears || 0;
            } else if (currencyType === 'etb') {
              revenueValue = yearlyData[year].etbArrears || 0;
            } else {
              revenueValue = yearlyData[year].totalArrears || 0;
            }
            
            const height = maxValue > 0 ? (revenueValue / maxValue) * 220 : 0;
            
            return (
              <Tooltip
                key={year}
                title={
                  <Box sx={{ p: 1 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>Year: {year}</Typography>
                    <Typography variant="body2" sx={{ color: '#fff' }}>
                      {currencyType === 'usd' ? `USD Arrears: ${currencySymbol}${formatNumber(revenueValue)}` :
                       currencyType === 'etb' ? `ETB Arrears: ${currencySymbol}${formatNumber(revenueValue)}` :
                       `Total Arrears: ${currencySymbol}${formatNumber(revenueValue)}`}
                    </Typography>
                    {currencyType === 'both' && (
                      <>
                        <Typography variant="body2" sx={{ color: '#fff' }}>
                          USD: ${formatNumber(yearlyData[year].usdArrears || 0)}
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#fff' }}>
                          ETB: {formatNumber(yearlyData[year].etbArrears || 0)} ETB
                        </Typography>
                      </>
                    )}
                  </Box>
                }
                arrow
                placement="top"
              >
                <Box sx={{ textAlign: 'center', minWidth: 80, cursor: 'pointer' }}>
                  <Box sx={{ 
                    height: height, 
                    width: '60px',
                    bgcolor: barColor,
                    borderRadius: '4px 4px 0 0',
                    margin: '0 auto',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      opacity: 0.8,
                      transform: 'translateY(-5px)',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                    }
                  }} />
                  <Typography variant="body2" sx={{ mt: 1, fontWeight: 'bold' }}>
                    {year}
                  </Typography>
                  <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
                    {currencySymbol}{formatNumber(revenueValue)}
                  </Typography>
                </Box>
              </Tooltip>
            );
          })}
        </Box>
        
        <Box sx={{ 
          width: '100%', 
          bgcolor: '#f5f5f5', 
          mt: 3,
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          p: 2,
          borderRadius: 1
        }}>
          <Typography variant="body2" color="textSecondary">
            Total Years: {years.length} | Range: {years[0]} - {years[years.length - 1]}
          </Typography>
        </Box>
      </Box>
    );
  };

  // Yearly Chart Dashboard Component (same layout as Code 2)
  const YearlyChartDashboard = () => {
    const [yearlyChartType, setYearlyChartType] = useState('line');
    const [yearlyCurrencyView, setYearlyCurrencyView] = useState('both');
    
    const yearlySummaryData = getYearlySummaryData();
    const parksListForYearly = [...new Set(filteredData.map(item => item.park_name).filter(Boolean))];
    
    const getYearlyDataForDisplay = () => {
      if (selectedParkForYearly !== "all") {
        return getYearlyDataForPark(selectedParkForYearly);
      }
      return yearlySummaryData;
    };
    
    const displayData = getYearlyDataForDisplay();
    
    const getChartTitle = () => {
      let title = "Yearly Arrears Trend";
      if (selectedParkForYearly !== "all") {
        title += ` - ${selectedParkForYearly}`;
      }
      if (yearlyCurrencyView === 'usd') {
        title += " (USD)";
      } else if (yearlyCurrencyView === 'etb') {
        title += " (ETB)";
      } else {
        title += " (USD + ETB)";
      }
      return title;
    };
    
    const getCurrencySymbol = () => {
      if (yearlyCurrencyView === 'usd') return "$";
      if (yearlyCurrencyView === 'etb') return "ETB";
      return yearlyCurrencyView === 'both' ? "$" : "";
    };
    
    const renderYearlyChart = () => {
      if (yearlyChartType === 'line') {
        return (
          <YearlyLineChart 
            title={getChartTitle()}
            yearlyData={displayData}
            currencySymbol={getCurrencySymbol()}
            currencyType={yearlyCurrencyView}
          />
        );
      } else {
        return (
          <YearlyBarChart 
            title={getChartTitle()}
            yearlyData={displayData}
            currencySymbol={getCurrencySymbol()}
            currencyType={yearlyCurrencyView}
          />
        );
      }
    };
    
    return (
      <Box sx={{ mt: 2, mb: 3 }}>
        {/* Controls for Yearly Chart - Same as Code 2 */}
        <Paper elevation={1} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Select Park</InputLabel>
                <Select
                  value={selectedParkForYearly}
                  onChange={(e) => setSelectedParkForYearly(e.target.value)}
                  label="Select Park"
                >
                  <MenuItem value="all">All Parks (Summary)</MenuItem>
                  {parksListForYearly.map((park) => (
                    <MenuItem key={park} value={park}>{park}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} md={2}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2" color="textSecondary">Chart Type:</Typography>
                <ToggleButtonGroup
                  value={yearlyChartType}
                  exclusive
                  onChange={(e, val) => val && setYearlyChartType(val)}
                  size="small"
                >
                  <ToggleButton value="line">
                    <Tooltip title="Line Chart"><ShowChartIcon fontSize="small" /></Tooltip>
                  </ToggleButton>
                  <ToggleButton value="bar">
                    <Tooltip title="Bar Chart"><BarChartIcon fontSize="small" /></Tooltip>
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
            </Grid>
            
            <Grid item xs={12} md={3}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2" color="textSecondary">Currency View:</Typography>
                <ToggleButtonGroup
                  value={yearlyCurrencyView}
                  exclusive
                  onChange={(e, val) => val && setYearlyCurrencyView(val)}
                  size="small"
                >
                  <ToggleButton value="both">Both</ToggleButton>
                  <ToggleButton value="usd">USD Only</ToggleButton>
                  <ToggleButton value="etb">ETB Only</ToggleButton>
                </ToggleButtonGroup>
              </Box>
            </Grid>
          </Grid>
        </Paper>
        
        {/* Yearly Chart Display - Same as Code 2 */}
        <Paper elevation={1} sx={{ p: 2, bgcolor: '#fafafa', borderRadius: 2 }}>
          {Object.keys(displayData).length === 0 ? (
            <Box sx={{ p: 5, textAlign: 'center' }}>
              <Typography variant="body2" color="textSecondary">
                No yearly data available for the selected filters
              </Typography>
            </Box>
          ) : (
            renderYearlyChart()
          )}
        </Paper>
      </Box>
    );
  };

  // Main Chart Component (By Park)
  const SimpleChart = () => {
    const usdChartData = getChartDataByCurrency('USD');
    const etbChartData = getChartDataByCurrency('ETB');
    
    return (
      <Box sx={{ mt: 2, mb: 3 }}>
        {/* Currency Selector */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
  <Typography variant="body2" color="textSecondary" sx={{ whiteSpace: 'nowrap' }}>
    Currency View:
  </Typography>
  <ToggleButtonGroup
    value={chartCurrency}
    exclusive
    onChange={(e, val) => val && setChartCurrency(val)}
    size="small"
    aria-label="currency view"
    sx={{
      '& .MuiToggleButton-root': {
        borderColor: 'gray',
        color: 'gray',
        textTransform: 'none',
        backgroundColor: 'transparent',
        '&:hover': {
          backgroundColor: '#f5f5f5',
          borderColor: '#1976d2',
        },
        '&.Mui-selected': {
          backgroundColor: '#e0e0e0',
          color: 'black',
          borderColor: 'gray',
          '&:hover': {
            backgroundColor: '#e0e0e0',
          }
        }
      }
    }}
  >
    <ToggleButton value="both" aria-label="both currencies">
      Both
    </ToggleButton>
    <ToggleButton value="USD" aria-label="USD only">
      USD Only
    </ToggleButton>
    <ToggleButton value="ETB" aria-label="ETB only">
      ETB Only
    </ToggleButton>
  </ToggleButtonGroup>
</Box>
        
        {/* Chart Display */}
        <Paper elevation={1} sx={{ p: 2, bgcolor: '#fafafa', borderRadius: 2 }}>
          <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center', mb: 2 }}>
            Arrears Analysis - {chartType === 'bar' ? 'Bar Chart' : 'Pie Chart'}
          </Typography>
          
          {chartCurrency === 'both' ? (
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Paper variant="outlined" sx={{ p: 1 }}>
                  <Box sx={{ p: 2 }}>
                    <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                      USD Arrears by Park - Total: ${formatNumber(totalUSD)}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2, minHeight: 250, justifyContent: 'center', flexWrap: 'wrap' }}>
                      {Object.entries(usdChartData).map(([park, parkData]) => {
                        const maxValue = Math.max(...Object.values(usdChartData).map(d => d.totalBalance), 0);
                        const height = maxValue > 0 ? (parkData.totalBalance / maxValue) * 180 : 0;
                        return (
                          <Tooltip key={park} title={`${park}: $${formatNumber(parkData.totalBalance)}`}>
                            <Box sx={{ textAlign: 'center', minWidth: 80 }}>
                              <Box sx={{ height: height, width: '50px', bgcolor: '#1976d2', borderRadius: '4px 4px 0 0', margin: '0 auto' }} />
                              <Typography variant="caption">{park.length > 12 ? park.substring(0, 10) + '...' : park}</Typography>
                            </Box>
                          </Tooltip>
                        );
                      })}
                    </Box>
                  </Box>
                </Paper>
              </Grid>
              <Grid item xs={12} md={6}>
                <Paper variant="outlined" sx={{ p: 1 }}>
                  <Box sx={{ p: 2 }}>
                    <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#d32f2f' }}>
                      ETB Arrears by Park - Total: {formatNumber(totalETB)} ETB
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2, minHeight: 250, justifyContent: 'center', flexWrap: 'wrap' }}>
                      {Object.entries(etbChartData).map(([park, parkData]) => {
                        const maxValue = Math.max(...Object.values(etbChartData).map(d => d.totalBalance), 0);
                        const height = maxValue > 0 ? (parkData.totalBalance / maxValue) * 180 : 0;
                        return (
                          <Tooltip key={park} title={`${park}: ${formatNumber(parkData.totalBalance)} ETB`}>
                            <Box sx={{ textAlign: 'center', minWidth: 80 }}>
                              <Box sx={{ height: height, width: '50px', bgcolor: '#d32f2f', borderRadius: '4px 4px 0 0', margin: '0 auto' }} />
                              <Typography variant="caption">{park.length > 12 ? park.substring(0, 10) + '...' : park}</Typography>
                            </Box>
                          </Tooltip>
                        );
                      })}
                    </Box>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          ) : chartCurrency === 'USD' ? (
            <Box sx={{ p: 2 }}>
              <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                USD Arrears by Park - Total: ${formatNumber(totalUSD)}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2, minHeight: 250, justifyContent: 'center', flexWrap: 'wrap' }}>
                {Object.entries(usdChartData).map(([park, parkData]) => {
                  const maxValue = Math.max(...Object.values(usdChartData).map(d => d.totalBalance), 0);
                  const height = maxValue > 0 ? (parkData.totalBalance / maxValue) * 180 : 0;
                  return (
                    <Tooltip key={park} title={`${park}: $${formatNumber(parkData.totalBalance)}`}>
                      <Box sx={{ textAlign: 'center', minWidth: 80 }}>
                        <Box sx={{ height: height, width: '50px', bgcolor: '#1976d2', borderRadius: '4px 4px 0 0', margin: '0 auto' }} />
                        <Typography variant="caption">{park.length > 12 ? park.substring(0, 10) + '...' : park}</Typography>
                      </Box>
                    </Tooltip>
                  );
                })}
              </Box>
            </Box>
          ) : (
            <Box sx={{ p: 2 }}>
              <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#d32f2f' }}>
                ETB Arrears by Park - Total: {formatNumber(totalETB)} ETB
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2, minHeight: 250, justifyContent: 'center', flexWrap: 'wrap' }}>
                {Object.entries(etbChartData).map(([park, parkData]) => {
                  const maxValue = Math.max(...Object.values(etbChartData).map(d => d.totalBalance), 0);
                  const height = maxValue > 0 ? (parkData.totalBalance / maxValue) * 180 : 0;
                  return (
                    <Tooltip key={park} title={`${park}: ${formatNumber(parkData.totalBalance)} ETB`}>
                      <Box sx={{ textAlign: 'center', minWidth: 80 }}>
                        <Box sx={{ height: height, width: '50px', bgcolor: '#d32f2f', borderRadius: '4px 4px 0 0', margin: '0 auto' }} />
                        <Typography variant="caption">{park.length > 12 ? park.substring(0, 10) + '...' : park}</Typography>
                      </Box>
                    </Tooltip>
                  );
                })}
              </Box>
            </Box>
          )}
        </Paper>
      </Box>
    );
  };

  return (
    <Box sx={{ width: '100%', bgcolor: '#f5f5f5', minHeight: '100vh', p: 3 }}>
      {/* Header Section */}
      <Typography variant="h6" gutterBottom sx={{ color: '#1a237e', fontWeight: 'bold', textAlign: 'center', mb: 1 }}>
        Arrears Report Dashboard
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center', mb: 3 }}>
        Monitor and manage outstanding payments across all industrial parks
      </Typography>
      
      {/* Summary Cards - Using abbreviated format */}
      <Grid container spacing={2} sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
        <Grid item xs={12} sm={6} md={4} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Card sx={{ bgcolor: 'white', boxShadow: 1, minHeight: '70px', width: '100%' }}>
            <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 }, textAlign: 'center' }}>
              <Typography variant="caption" sx={{ color: '#999', fontSize: '0.7rem' }}>
                Total Outstanding Arrears
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, my: 0.5 }}>
                <Typography variant="body2" sx={{ color: '#d32f2f', fontWeight: 'normal', fontSize: '0.875rem' }}>
                  USD: ${formatNumberWithAbbreviation(totalUSD)}
                </Typography>
                <Box sx={{ width: '1px', height: '20px', bgcolor: '#ddd' }} />
                <Typography variant="body2" sx={{ color: '#d32f2f', fontWeight: 'normal', fontSize: '0.875rem' }}>
                  ETB: {formatNumberWithAbbreviation(totalETB)} ETB
                </Typography>
              </Box>
              <Typography variant="caption" sx={{ color: '#999', fontSize: '0.7rem', display: 'block', mt: 0.5 }}>
                Across all parks
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Card sx={{ bgcolor: 'white', boxShadow: 1, minHeight: '70px', width: '100%' }}>
            <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 }, textAlign: 'center' }}>
              <Typography variant="caption" gutterBottom sx={{ color: '#666', display: 'block' }}>
                Critical overdue Accounts
              </Typography>
              <Typography variant="body2" sx={{ my: 0.5, color: 'black', fontWeight: 'normal', fontSize: '0.875rem' }}>
                {formatNumberWithAbbreviation(summaryStats.criticalAccounts)}
              </Typography>
              <Typography variant="caption" sx={{ color: '#999', fontSize: '0.7rem' }}>
                Over 90 days overdue
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Card sx={{ bgcolor: 'white', boxShadow: 1, minHeight: '70px', width: '100%' }}>
            <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 }, textAlign: 'center' }}>
              <Typography variant="caption" gutterBottom sx={{ color: '#666', display: 'block' }}>
                Active overdue Companies
              </Typography>
              <Typography variant="body2" sx={{ my: 0.5, color: 'black', fontWeight: 'normal', fontSize: '0.875rem' }}>
                {formatNumberWithAbbreviation(summaryStats.totalCompanies)}
              </Typography>
              <Typography variant="caption" sx={{ color: '#999', fontSize: '0.7rem' }}>
                With outstanding balances
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      
      {/* Filters Section */}
      <Paper elevation={2} sx={{ p: 2, mb: 3, borderRadius: 2 }}>
        <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              size="small"
              placeholder="Search by company, agreement ID or park..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: searchTerm && (
                  <InputAdornment position="end">
                    <ClearIcon
                      sx={{ cursor: 'pointer' }}
                      onClick={() => setSearchTerm("")}
                    />
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          
          <Grid item xs={12} md={1.5}>
            <FormControl fullWidth size="small">
              <InputLabel>Park</InputLabel>
              <Select
                value={selectedPark}
                onChange={(e) => setSelectedPark(e.target.value)}
                label="Park"
              >
                <MenuItem value="all">All Parks</MenuItem>
                {parksList.map((park) => (
                  <MenuItem key={park} value={park}>{park}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} md={1.5}>
            <FormControl fullWidth size="small">
              <InputLabel>Status</InputLabel>
              <Select
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
                label="Status"
              >
                <MenuItem value="all">All Status</MenuItem>
                <MenuItem value="Critical">Critical (90+ days)</MenuItem>
                <MenuItem value="Severe">Severe (60-89 days)</MenuItem>
                <MenuItem value="Moderate">Moderate (30-59 days)</MenuItem>
                <MenuItem value="Mild">Mild (1-29 days)</MenuItem>
                <MenuItem value="Current">Current</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          {/* Currency Dropdown */}
          <Grid item xs={12} md={1.5}>
            <FormControl fullWidth size="small">
              <InputLabel>Currency</InputLabel>
              <Select
                value={selectedCurrency}
                onChange={(e) => setSelectedCurrency(e.target.value)}
                label="Currency"
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="usd">USD</MenuItem>
                <MenuItem value="birr">Birr</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} md={2}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                fullWidth
                variant="outlined"
                onClick={resetFilters}
                startIcon={<ClearIcon />}
                size="small"
                sx={{ 
                  textTransform: 'none',
                  borderColor: '#1976d2',
                  color: '#1976d2',
                  mr: 0.5,
                  '&:hover': {
                    borderColor: '#1565c0',
                    backgroundColor: 'rgba(25, 118, 210, 0.04)',
                  },
                }}
              >
                Reset
              </Button>
              <Button
                fullWidth
                variant="contained"
                color="inherit"
                size="small"
                onClick={handleExportCSV}
                startIcon={<DownloadIcon />}
                sx={{ textTransform: 'none' }}
              >
                Export
              </Button>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={2.5}>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Typography variant="body2" color="textSecondary" sx={{ mr: 0.5 }}>
                Chart:
              </Typography>
              <ToggleButtonGroup
                value={chartType}
                exclusive
                onChange={handleChartTypeChange}
                size="small"
                aria-label="chart type"
              >
                <ToggleButton value="bar" aria-label="bar chart">
                  <Tooltip title="Bar Chart">
                    <BarChartIcon fontSize="small" />
                  </Tooltip>
                </ToggleButton>
                <ToggleButton value="pie" aria-label="pie chart">
                  <Tooltip title="Pie Chart">
                    <PieChartIcon fontSize="small" />
                  </Tooltip>
                </ToggleButton>
              </ToggleButtonGroup>
              <Button 
                variant="outlined" 
                size="small" 
                onClick={() => setShowChart(!showChart)} 
                sx={{ 
                  minWidth: '120px', 
                  textTransform: 'none',
                  borderColor: '#1976d2',
                  color: '#1976d2',
                  '&:hover': { 
                    borderColor: '#1976d2',
                    backgroundColor: '#f5f5f5',
                    color: '#1976d2'
                  } 
                }}
              >
                {showChart ? "Hide Chart" : "Show Chart"}
              </Button>
            </Box>
          </Grid>
        </Grid>
        
        {/* Year and Month Range Filters */}
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Year From</InputLabel>
              <Select
                value={startYear}
                onChange={(e) => setStartYear(e.target.value)}
                label="Year From"
              >
                {years.map((year) => (
                  <MenuItem key={year} value={year}>{year === "all" ? "All Years" : year}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Year To</InputLabel>
              <Select
                value={endYear}
                onChange={(e) => setEndYear(e.target.value)}
                label="Year To"
              >
                {years.map((year) => (
                  <MenuItem key={year} value={year}>{year === "all" ? "All Years" : year}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Month From</InputLabel>
              <Select
                value={startMonth}
                onChange={(e) => setStartMonth(e.target.value)}
                label="Month From"
              >
                {months.map((month) => (
                  <MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Month To</InputLabel>
              <Select
                value={endMonth}
                onChange={(e) => setEndMonth(e.target.value)}
                label="Month To"
              >
                {months.map((month) => (
                  <MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>
      
      {/* Conditional Rendering: Show Chart OR Table */}
      {showChart ? (
        <>
          {/* Chart Type Toggle Buttons - Same as Code 2 */}
          <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button
  variant={!showYearlyChart ? 'contained' : 'outlined'}
  size="small"
  onClick={() => setShowYearlyChart(false)}
  sx={{ 
    textTransform: 'none',
    minWidth: '120px',
    borderColor: '#1976d2',
    color: '#1976d2',
    ...(!showYearlyChart ? {
      backgroundColor: '#e0e0e0',
      '&:hover': {
        backgroundColor: '#e0e0e0',
      }
    } : {
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: '#e0e0e0',
      }
    })
  }}
>
  By Park
</Button>

<Button
  variant={showYearlyChart ? 'contained' : 'outlined'}
  size="small"
  onClick={() => setShowYearlyChart(true)}
  sx={{ 
    textTransform: 'none',
    minWidth: '120px',
    borderColor: '#1976d2',
    color: '#1976d2',
    ...(showYearlyChart ? {
      backgroundColor: '#e0e0e0',
      '&:hover': {
        backgroundColor: '#e0e0e0',
      }
    } : {
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: '#e0e0e0',
      }
    })
  }}
>
  Yearly Trend
</Button>
</Box>
         
          {!showYearlyChart ? (
            <SimpleChart />
          ) : (
            <YearlyChartDashboard />
          )}
        </>
      ) : (
        <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
              <CircularProgress />
              <Typography sx={{ ml: 2 }}>Loading arrears data...</Typography>
            </Box>
          ) : filteredData.length === 0 ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
              <Typography sx={{ color: 'text.secondary' }}>No arrears data available</Typography>
            </Box>
          ) : (
            <>
              <Box sx={{ p: 2, bgcolor: '#fafafa', borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  Arrears Records
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Showing {filteredData.length} of {arrearsData.length} records
                </Typography>
              </Box>
              
              <TableContainer>
                <Table size="small">
                  <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                    <TableRow>
                      <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Agreement ID</TableCell>
                      <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Company Name</TableCell>
                      <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Park</TableCell>
                      <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Payment Mode</TableCell>
                      <TableCell align="right" sx={{ py: 1, fontWeight: 'bold' }}>Outstanding</TableCell>
                      <TableCell sx={{ py: 1, fontWeight: 'bold' }}>Due Date</TableCell>
                      <TableCell align="center" sx={{ py: 1, fontWeight: 'bold' }}>Days Overdue</TableCell>
                     
                      <TableCell align="center" sx={{ py: 1, fontWeight: 'bold' }}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {getCurrentPageData().map((row) => (
                      <TableRow key={row.id} hover>
                        <TableCell sx={{ py: 0.5 }}>{row.agreement_id}</TableCell>
                        <TableCell sx={{ py: 0.5 }}>{row.company_name}</TableCell>
                        <TableCell sx={{ py: 0.5 }}>{row.park_name}</TableCell>
                        <TableCell sx={{ py: 0.5 }}>{row.payment_mode}</TableCell>
                        <TableCell align="right" sx={{ py: 0.5, color: row.outstanding > 0 ? '#d32f2f' : 'inherit', fontWeight: row.outstanding > 0 ? 'bold' : 'normal' }}>
                          {row.formattedOutstanding}
                        </TableCell>
                        <TableCell sx={{ py: 0.5 }}>{row.due_date_formatted}</TableCell>
                        <TableCell align="center" sx={{ py: 0.5 }}>
                          {row.overdue_days > 0 ? `${row.overdue_days} days` : 'Current'}
                        </TableCell>
                        
                        <TableCell align="center" sx={{ py: 0.5 }}>
                          <Tooltip title="View Details">
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() => handleViewDetails(row)}
                            >
                              <VisibilityIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={filteredData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
              
              {/* Summary Filter at Bottom Right */}
              <Box sx={{ 
  p: 2, 
  bgcolor: '#fafafa', 
  borderTop: '1px solid #e0e0e0',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 3
}}>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <Typography variant="caption" sx={{ color: '#666', fontWeight: 'bold' }}>
      Summary: {`Total Records: ${filteredData.length}`} | {' '}
      {`Total USD: $${formatNumber(totalUSD)}`} | {' '}
      {`Total ETB: ${formatNumber(totalETB)} ETB`} | {' '}
      {`Critical: ${summaryStats.criticalAccounts}`}
    </Typography>
  </Box>
</Box>
            </>
          )}
        </Paper>
      )}
      
      {/* Details Dialog */}
      <Dialog open={openDetailsDialog} onClose={() => setOpenDetailsDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h5" sx={{ color: 'black', fontWeight: 'normal' }}>
              Arrear Details
            </Typography>
            <IconButton onClick={() => setOpenDetailsDialog(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent>
          {selectedArrear && (
            <Box sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
                      Agreement ID:
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
                      {selectedArrear.agreement_id}
                    </Typography>
                  </Box>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
                      Company Name:
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
                      {selectedArrear.company_name}
                    </Typography>
                  </Box>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
                      Park Name:
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
                      {selectedArrear.park_name}
                    </Typography>
                  </Box>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
                      Payment Mode:
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
                      {selectedArrear.payment_mode}
                    </Typography>
                  </Box>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
                      Due Date:
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
                      {selectedArrear.due_date_formatted}
                    </Typography>
                  </Box>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
                      Days Overdue:
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
                      {selectedArrear.overdue_days > 0 ? `${selectedArrear.overdue_days} days` : 'Current'}
                    </Typography>
                  </Box>
                </Grid>
                
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: '#1A237E', fontWeight: 'normal', minWidth: '120px' }}>
                      Outstanding Balance:
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: 'black', fontWeight: 'normal' }}>
                      {selectedArrear.formattedOutstanding}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button onClick={() => setOpenDetailsDialog(false)} variant="outlined" sx={{ color: 'black', borderColor: '#ccc' }}>Close</Button>
        </Box>
      </Dialog>
      
      {/* Payment Dialog */}
      <Dialog open={openPaymentDialog} onClose={() => setOpenPaymentDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography variant="h5" sx={{ color: '#1a237e', fontWeight: 'bold' }}>
            Record Payment
          </Typography>
        </DialogTitle>
        <Divider />
        <DialogContent>
          {selectedArrear && (
            <Box sx={{ mt: 2 }}>
              <Alert severity="info" sx={{ mb: 3 }}>
                <Typography variant="body2">
                  <strong>Company:</strong> {selectedArrear.company_name}<br />
                  <strong>Payment Mode:</strong> {selectedArrear.payment_mode}<br />
                  <strong>Outstanding Balance:</strong> {selectedArrear.formattedOutstanding}
                </Typography>
              </Alert>
              
              <TextField
                fullWidth
                label={`Payment Amount (${selectedArrear.payment_mode === "USD" ? "$" : "ETB"})`}
                type="number"
                value={paymentAmount}
                onChange={(e) => setPaymentAmount(e.target.value)}
                placeholder="Enter amount"
                InputProps={{
                  startAdornment: <InputAdornment position="start">{selectedArrear.payment_mode === "USD" ? "$" : "ETB"}</InputAdornment>
                }}
                sx={{ mb: 2 }}
                autoFocus
              />
              
              <TextField
                fullWidth
                label="Payment Note (Optional)"
                multiline
                rows={3}
                value={paymentNote}
                onChange={(e) => setPaymentNote(e.target.value)}
                placeholder="Add any notes about this payment..."
              />
            </Box>
          )}
        </DialogContent>
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button onClick={() => {
            setOpenPaymentDialog(false);
            setPaymentAmount("");
            setPaymentNote("");
          }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handlePayment}
            disabled={processingPayment || !paymentAmount}
          >
            {processingPayment ? <CircularProgress size={24} /> : "Process Payment"}
          </Button>
        </Box>
      </Dialog>
      
      {/* Success Dialog */}
      <Dialog open={openSuccessDialog} onClose={() => setOpenSuccessDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ bgcolor: '#4caf50', color: 'white' }}>
          <Box display="flex" alignItems="center" gap={1}>
            <CheckCircleIcon />
            <Typography variant="h6">Payment Successful!</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          {paymentSuccess && (
            <Box sx={{ mt: 2, p: 2 }}>
              <Alert severity="success" sx={{ mb: 2 }}>
                Payment has been recorded successfully
              </Alert>
              
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Amount Paid</Typography>
                  <Typography variant="h6" sx={{ color: '#4caf50' }}>
                    {formatNumber(paymentSuccess.amount)} {paymentSuccess.paymentMode === "USD" ? "$" : "ETB"}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Payment Date</Typography>
                  <Typography variant="body1">{formatDate(paymentSuccess.date)}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Previous Balance</Typography>
                  <Typography variant="body1">
                    {formatNumber(paymentSuccess.previousBalance)} {paymentSuccess.paymentMode === "USD" ? "$" : "ETB"}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">New Balance</Typography>
                  <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                    {formatNumber(paymentSuccess.newBalance)} {paymentSuccess.paymentMode === "USD" ? "$" : "ETB"}
                  </Typography>
                </Grid>
                {paymentSuccess.note && (
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="textSecondary">Note</Typography>
                    <Typography variant="body2">{paymentSuccess.note}</Typography>
                  </Grid>
                )}
              </Grid>
            </Box>
          )}
        </DialogContent>
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button 
            variant="contained" 
            onClick={() => {
              setOpenSuccessDialog(false);
              setPaymentSuccess(null);
            }}
          >
            Close
          </Button>
        </Box>
      </Dialog>
    </Box>
  );
}